/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Api
 * Unified Inbox API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AddTaskFieldToListRequest,
  AddTrustedImageSenderRequest,
  AdoProjectsResponse,
  AnalyticsResponse,
  AnthropicConversation,
  AnthropicConversationInput,
  AnthropicConversationWithMessages,
  AnthropicError,
  AnthropicMessage,
  AnthropicMessageInput,
  ApiError,
  AppSettings,
  AuthStatus,
  CalendarEvent,
  ChatChannel,
  ComposeBody,
  ConnectJiraRequest,
  ConnectorRequest,
  ContactCard,
  CreateChatChannelRequest,
  CreateDocRequest,
  CreateDraftRequest,
  CreateListRequest,
  CreateMeetingRequest,
  CreatePinnedViewRequest,
  CreateTaskCommentRequest,
  CreateTaskFieldRequest,
  CreateTaskRequest,
  CreateTaskStatusRequest,
  CreateTaskTagRequest,
  CreateTaskTimeBlockRequest,
  CreateTaskViewRequest,
  DeleteFolderRequest,
  Doc,
  DocSummary,
  Draft,
  EmailReplyBody,
  Feedback,
  FileMessageToFolderRequest,
  Folder,
  ForwardBody,
  GetAnalyticsParams,
  GetContactsParams,
  GetMessagesParams,
  GetPresenceParams,
  GetTaskSummaryParams,
  HealthStatus,
  InboxStats,
  JiraIssueDetail,
  JiraPriority,
  JiraProjectsResponse,
  JoinWaitlistRequest,
  List,
  MessageUpdate,
  NativeReplyRequest,
  OkResult,
  OutOfOffice,
  PinnedView,
  PresenceMap,
  RenameFolderRequest,
  ReorderFoldersRequest,
  ReorderPinnedViewsRequest,
  ReorderTasksRequest,
  ReplyBody,
  RequestConnectorRequest,
  RespondInviteBody,
  ResyncRequest,
  ResyncResult,
  Rule,
  RuleInput,
  SendNativeChatMessage200,
  SlackChannel,
  SubmitFeedbackRequest,
  SyncResult,
  Task,
  TaskComment,
  TaskField,
  TaskFieldValue,
  TaskStatus,
  TaskSummary,
  TaskTag,
  TaskTimeBlock,
  TaskView,
  TeamsChannel,
  TeamsChat,
  TeamsTeam,
  UnifiedMessage,
  UpdateAppSettingsRequest,
  UpdateDocRequest,
  UpdateDraftRequest,
  UpdateListRequest,
  UpdatePinnedViewRequest,
  UpdateProjectSelectionRequest,
  UpdateTaskFieldRequest,
  UpdateTaskRequest,
  UpdateTaskStatusRequest,
  UpdateTaskTagRequest,
  UpdateTaskTimeBlockRequest,
  UpdateTaskViewRequest,
  UpdateWellbeingSettingsRequest,
  UpsertTaskFieldValueRequest,
  WaitlistSignup,
  WellbeingSettings
} from './api.schemas';

import { customFetch } from '../custom-fetch';
import type { ErrorType , BodyType } from '../custom-fetch';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getHealthCheckUrl = () => {




  return `/api/healthz`
}

/**
 * Returns server health status
 * @summary Health check
 */
export const healthCheck = async ( options?: Parameters<typeof customFetch>[1]): Promise<HealthStatus> => {

  return customFetch<HealthStatus>(getHealthCheckUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHealthCheckQueryKey = () => {
    return [
    `/api/healthz`
    ] as const;
    }


export const getHealthCheckQueryOptions = <TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthCheckQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({ signal }) => healthCheck({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData> & { queryKey: QueryKey }
}

export type HealthCheckQueryResult = NonNullable<Awaited<ReturnType<typeof healthCheck>>>
export type HealthCheckQueryError = ErrorType<unknown>


/**
 * @summary Health check
 */

export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getHealthCheckQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getJoinWaitlistUrl = () => {




  return `/api/waitlist`
}

/**
 * @summary Join the waiting list for a paid plan — public, no authentication required
 */
export const joinWaitlist = async (joinWaitlistRequest: JoinWaitlistRequest, options?: Parameters<typeof customFetch>[1]): Promise<WaitlistSignup> => {

  return customFetch<WaitlistSignup>(getJoinWaitlistUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(joinWaitlistRequest)
  }
);}





export const getJoinWaitlistMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof joinWaitlist>>, TError,{data: BodyType<JoinWaitlistRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof joinWaitlist>>, TError,{data: BodyType<JoinWaitlistRequest>}, TContext> => {

const mutationKey = ['joinWaitlist'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof joinWaitlist>>, {data: BodyType<JoinWaitlistRequest>}> = (props) => {
          const {data} = props ?? {};

          return  joinWaitlist(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type JoinWaitlistMutationResult = NonNullable<Awaited<ReturnType<typeof joinWaitlist>>>
    export type JoinWaitlistMutationBody = BodyType<JoinWaitlistRequest>
    export type JoinWaitlistMutationError = ErrorType<ApiError>

    /**
 * @summary Join the waiting list for a paid plan — public, no authentication required
 */
export const useJoinWaitlist = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof joinWaitlist>>, TError,{data: BodyType<JoinWaitlistRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof joinWaitlist>>,
        TError,
        {data: BodyType<JoinWaitlistRequest>},
        TContext
      > => {
      return useMutation(getJoinWaitlistMutationOptions(options));
    }

export const getRequestConnectorUrl = () => {




  return `/api/connector-requests`
}

/**
 * @summary Request a new connector — public, no authentication required
 */
export const requestConnector = async (requestConnectorRequest: RequestConnectorRequest, options?: Parameters<typeof customFetch>[1]): Promise<ConnectorRequest> => {

  return customFetch<ConnectorRequest>(getRequestConnectorUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(requestConnectorRequest)
  }
);}





export const getRequestConnectorMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestConnector>>, TError,{data: BodyType<RequestConnectorRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof requestConnector>>, TError,{data: BodyType<RequestConnectorRequest>}, TContext> => {

const mutationKey = ['requestConnector'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestConnector>>, {data: BodyType<RequestConnectorRequest>}> = (props) => {
          const {data} = props ?? {};

          return  requestConnector(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestConnectorMutationResult = NonNullable<Awaited<ReturnType<typeof requestConnector>>>
    export type RequestConnectorMutationBody = BodyType<RequestConnectorRequest>
    export type RequestConnectorMutationError = ErrorType<ApiError>

    /**
 * @summary Request a new connector — public, no authentication required
 */
export const useRequestConnector = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestConnector>>, TError,{data: BodyType<RequestConnectorRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof requestConnector>>,
        TError,
        {data: BodyType<RequestConnectorRequest>},
        TContext
      > => {
      return useMutation(getRequestConnectorMutationOptions(options));
    }

export const getSubmitFeedbackUrl = () => {




  return `/api/feedback`
}

/**
 * @summary Submit a bug report or feature request — public, no authentication required
 */
export const submitFeedback = async (submitFeedbackRequest: SubmitFeedbackRequest, options?: Parameters<typeof customFetch>[1]): Promise<Feedback> => {

  return customFetch<Feedback>(getSubmitFeedbackUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(submitFeedbackRequest)
  }
);}





export const getSubmitFeedbackMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitFeedback>>, TError,{data: BodyType<SubmitFeedbackRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof submitFeedback>>, TError,{data: BodyType<SubmitFeedbackRequest>}, TContext> => {

const mutationKey = ['submitFeedback'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitFeedback>>, {data: BodyType<SubmitFeedbackRequest>}> = (props) => {
          const {data} = props ?? {};

          return  submitFeedback(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitFeedbackMutationResult = NonNullable<Awaited<ReturnType<typeof submitFeedback>>>
    export type SubmitFeedbackMutationBody = BodyType<SubmitFeedbackRequest>
    export type SubmitFeedbackMutationError = ErrorType<ApiError>

    /**
 * @summary Submit a bug report or feature request — public, no authentication required
 */
export const useSubmitFeedback = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitFeedback>>, TError,{data: BodyType<SubmitFeedbackRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof submitFeedback>>,
        TError,
        {data: BodyType<SubmitFeedbackRequest>},
        TContext
      > => {
      return useMutation(getSubmitFeedbackMutationOptions(options));
    }

export const getDisconnectGmailUrl = () => {




  return `/api/auth/google`
}

/**
 * @summary Disconnect Gmail account
 */
export const disconnectGmail = async ( options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDisconnectGmailUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDisconnectGmailMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disconnectGmail>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof disconnectGmail>>, TError,void, TContext> => {

const mutationKey = ['disconnectGmail'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disconnectGmail>>, void> = () => {


          return  disconnectGmail(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisconnectGmailMutationResult = NonNullable<Awaited<ReturnType<typeof disconnectGmail>>>

    export type DisconnectGmailMutationError = ErrorType<ApiError>

    /**
 * @summary Disconnect Gmail account
 */
export const useDisconnectGmail = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disconnectGmail>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof disconnectGmail>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDisconnectGmailMutationOptions(options));
    }

export const getDisconnectSlackUrl = () => {




  return `/api/auth/slack`
}

/**
 * @summary Disconnect Slack account
 */
export const disconnectSlack = async ( options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDisconnectSlackUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDisconnectSlackMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disconnectSlack>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof disconnectSlack>>, TError,void, TContext> => {

const mutationKey = ['disconnectSlack'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disconnectSlack>>, void> = () => {


          return  disconnectSlack(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisconnectSlackMutationResult = NonNullable<Awaited<ReturnType<typeof disconnectSlack>>>

    export type DisconnectSlackMutationError = ErrorType<ApiError>

    /**
 * @summary Disconnect Slack account
 */
export const useDisconnectSlack = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disconnectSlack>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof disconnectSlack>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDisconnectSlackMutationOptions(options));
    }

export const getDisconnectOutlookUrl = () => {




  return `/api/auth/outlook`
}

/**
 * @summary Disconnect Outlook account
 */
export const disconnectOutlook = async ( options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDisconnectOutlookUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDisconnectOutlookMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disconnectOutlook>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof disconnectOutlook>>, TError,void, TContext> => {

const mutationKey = ['disconnectOutlook'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disconnectOutlook>>, void> = () => {


          return  disconnectOutlook(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisconnectOutlookMutationResult = NonNullable<Awaited<ReturnType<typeof disconnectOutlook>>>

    export type DisconnectOutlookMutationError = ErrorType<ApiError>

    /**
 * @summary Disconnect Outlook account
 */
export const useDisconnectOutlook = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disconnectOutlook>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof disconnectOutlook>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDisconnectOutlookMutationOptions(options));
    }

export const getConnectJiraUrl = () => {




  return `/api/auth/jira`
}

/**
 * @summary Connect a Jira account via API token (validated with a live request before saving)
 */
export const connectJira = async (connectJiraRequest: ConnectJiraRequest, options?: Parameters<typeof customFetch>[1]): Promise<OkResult> => {

  return customFetch<OkResult>(getConnectJiraUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(connectJiraRequest)
  }
);}





export const getConnectJiraMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof connectJira>>, TError,{data: BodyType<ConnectJiraRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof connectJira>>, TError,{data: BodyType<ConnectJiraRequest>}, TContext> => {

const mutationKey = ['connectJira'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof connectJira>>, {data: BodyType<ConnectJiraRequest>}> = (props) => {
          const {data} = props ?? {};

          return  connectJira(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConnectJiraMutationResult = NonNullable<Awaited<ReturnType<typeof connectJira>>>
    export type ConnectJiraMutationBody = BodyType<ConnectJiraRequest>
    export type ConnectJiraMutationError = ErrorType<ApiError>

    /**
 * @summary Connect a Jira account via API token (validated with a live request before saving)
 */
export const useConnectJira = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof connectJira>>, TError,{data: BodyType<ConnectJiraRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof connectJira>>,
        TError,
        {data: BodyType<ConnectJiraRequest>},
        TContext
      > => {
      return useMutation(getConnectJiraMutationOptions(options));
    }

export const getDisconnectJiraUrl = () => {




  return `/api/auth/jira`
}

/**
 * @summary Disconnect Jira account
 */
export const disconnectJira = async ( options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDisconnectJiraUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDisconnectJiraMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disconnectJira>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof disconnectJira>>, TError,void, TContext> => {

const mutationKey = ['disconnectJira'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disconnectJira>>, void> = () => {


          return  disconnectJira(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisconnectJiraMutationResult = NonNullable<Awaited<ReturnType<typeof disconnectJira>>>

    export type DisconnectJiraMutationError = ErrorType<ApiError>

    /**
 * @summary Disconnect Jira account
 */
export const useDisconnectJira = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disconnectJira>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof disconnectJira>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDisconnectJiraMutationOptions(options));
    }

export const getDisconnectAdoUrl = () => {




  return `/api/auth/ado`
}

/**
 * @summary Disconnect Azure DevOps account
 */
export const disconnectAdo = async ( options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDisconnectAdoUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDisconnectAdoMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disconnectAdo>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof disconnectAdo>>, TError,void, TContext> => {

const mutationKey = ['disconnectAdo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disconnectAdo>>, void> = () => {


          return  disconnectAdo(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisconnectAdoMutationResult = NonNullable<Awaited<ReturnType<typeof disconnectAdo>>>

    export type DisconnectAdoMutationError = ErrorType<ApiError>

    /**
 * @summary Disconnect Azure DevOps account
 */
export const useDisconnectAdo = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disconnectAdo>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof disconnectAdo>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDisconnectAdoMutationOptions(options));
    }

export const getGetAuthStatusUrl = () => {




  return `/api/auth/status`
}

/**
 * @summary Get connection status for all integrations
 */
export const getAuthStatus = async ( options?: Parameters<typeof customFetch>[1]): Promise<AuthStatus> => {

  return customFetch<AuthStatus>(getGetAuthStatusUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAuthStatusQueryKey = () => {
    return [
    `/api/auth/status`
    ] as const;
    }


export const getGetAuthStatusQueryOptions = <TData = Awaited<ReturnType<typeof getAuthStatus>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAuthStatus>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAuthStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuthStatus>>> = ({ signal }) => getAuthStatus({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAuthStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAuthStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getAuthStatus>>>
export type GetAuthStatusQueryError = ErrorType<unknown>


/**
 * @summary Get connection status for all integrations
 */

export function useGetAuthStatus<TData = Awaited<ReturnType<typeof getAuthStatus>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAuthStatus>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAuthStatusQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetMessagesUrl = (params?: GetMessagesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/messages?${stringifiedParams}` : `/api/messages`
}

/**
 * @summary Get unified inbox messages
 */
export const getMessages = async (params?: GetMessagesParams, options?: Parameters<typeof customFetch>[1]): Promise<UnifiedMessage[]> => {

  return customFetch<UnifiedMessage[]>(getGetMessagesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMessagesQueryKey = (params?: GetMessagesParams,) => {
    return [
    `/api/messages`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetMessagesQueryOptions = <TData = Awaited<ReturnType<typeof getMessages>>, TError = ErrorType<unknown>>(params?: GetMessagesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMessages>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMessagesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMessages>>> = ({ signal }) => getMessages(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMessages>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMessagesQueryResult = NonNullable<Awaited<ReturnType<typeof getMessages>>>
export type GetMessagesQueryError = ErrorType<unknown>


/**
 * @summary Get unified inbox messages
 */

export function useGetMessages<TData = Awaited<ReturnType<typeof getMessages>>, TError = ErrorType<unknown>>(
 params?: GetMessagesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMessages>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMessagesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSyncMessagesUrl = () => {




  return `/api/messages/sync`
}

/**
 * @summary Trigger a sync from Gmail, Slack, and Outlook
 */
export const syncMessages = async ( options?: Parameters<typeof customFetch>[1]): Promise<SyncResult> => {

  return customFetch<SyncResult>(getSyncMessagesUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getSyncMessagesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncMessages>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof syncMessages>>, TError,void, TContext> => {

const mutationKey = ['syncMessages'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof syncMessages>>, void> = () => {


          return  syncMessages(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SyncMessagesMutationResult = NonNullable<Awaited<ReturnType<typeof syncMessages>>>

    export type SyncMessagesMutationError = ErrorType<unknown>

    /**
 * @summary Trigger a sync from Gmail, Slack, and Outlook
 */
export const useSyncMessages = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncMessages>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof syncMessages>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getSyncMessagesMutationOptions(options));
    }

export const getResyncProviderUrl = () => {




  return `/api/messages/resync`
}

/**
 * @summary Re-sync one connected provider on demand — deep re-sync with SSE progress for mail, a normal sync pass for the rest
 */
export const resyncProvider = async (resyncRequest: ResyncRequest, options?: Parameters<typeof customFetch>[1]): Promise<ResyncResult> => {

  return customFetch<ResyncResult>(getResyncProviderUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(resyncRequest)
  }
);}





export const getResyncProviderMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resyncProvider>>, TError,{data: BodyType<ResyncRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof resyncProvider>>, TError,{data: BodyType<ResyncRequest>}, TContext> => {

const mutationKey = ['resyncProvider'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resyncProvider>>, {data: BodyType<ResyncRequest>}> = (props) => {
          const {data} = props ?? {};

          return  resyncProvider(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResyncProviderMutationResult = NonNullable<Awaited<ReturnType<typeof resyncProvider>>>
    export type ResyncProviderMutationBody = BodyType<ResyncRequest>
    export type ResyncProviderMutationError = ErrorType<ApiError>

    /**
 * @summary Re-sync one connected provider on demand — deep re-sync with SSE progress for mail, a normal sync pass for the rest
 */
export const useResyncProvider = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resyncProvider>>, TError,{data: BodyType<ResyncRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof resyncProvider>>,
        TError,
        {data: BodyType<ResyncRequest>},
        TContext
      > => {
      return useMutation(getResyncProviderMutationOptions(options));
    }

export const getGetMessageUrl = (id: string,) => {




  return `/api/messages/${id}`
}

/**
 * @summary Get a single message
 */
export const getMessage = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<UnifiedMessage> => {

  return customFetch<UnifiedMessage>(getGetMessageUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMessageQueryKey = (id: string,) => {
    return [
    `/api/messages/${id}`
    ] as const;
    }


export const getGetMessageQueryOptions = <TData = Awaited<ReturnType<typeof getMessage>>, TError = ErrorType<ApiError>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMessage>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMessageQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMessage>>> = ({ signal }) => getMessage(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMessage>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMessageQueryResult = NonNullable<Awaited<ReturnType<typeof getMessage>>>
export type GetMessageQueryError = ErrorType<ApiError>


/**
 * @summary Get a single message
 */

export function useGetMessage<TData = Awaited<ReturnType<typeof getMessage>>, TError = ErrorType<ApiError>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMessage>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMessageQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateMessageUrl = (id: string,) => {




  return `/api/messages/${id}`
}

/**
 * @summary Update a message (mark read, add labels)
 */
export const updateMessage = async (id: string,
    messageUpdate: MessageUpdate, options?: Parameters<typeof customFetch>[1]): Promise<UnifiedMessage> => {

  return customFetch<UnifiedMessage>(getUpdateMessageUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(messageUpdate)
  }
);}





export const getUpdateMessageMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMessage>>, TError,{id: string;data: BodyType<MessageUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateMessage>>, TError,{id: string;data: BodyType<MessageUpdate>}, TContext> => {

const mutationKey = ['updateMessage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateMessage>>, {id: string;data: BodyType<MessageUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateMessage(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateMessageMutationResult = NonNullable<Awaited<ReturnType<typeof updateMessage>>>
    export type UpdateMessageMutationBody = BodyType<MessageUpdate>
    export type UpdateMessageMutationError = ErrorType<ApiError>

    /**
 * @summary Update a message (mark read, add labels)
 */
export const useUpdateMessage = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMessage>>, TError,{id: string;data: BodyType<MessageUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateMessage>>,
        TError,
        {id: string;data: BodyType<MessageUpdate>},
        TContext
      > => {
      return useMutation(getUpdateMessageMutationOptions(options));
    }

export const getDeleteMessageUrl = (id: string,) => {




  return `/api/messages/${id}`
}

/**
 * @summary Move a single email message to Trash (Gmail/Outlook only, not Slack) — recoverable via POST /messages/{id}/restore
 */
export const deleteMessage = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDeleteMessageUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteMessageMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMessage>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteMessage>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteMessage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteMessage>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteMessage(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteMessageMutationResult = NonNullable<Awaited<ReturnType<typeof deleteMessage>>>

    export type DeleteMessageMutationError = ErrorType<ApiError>

    /**
 * @summary Move a single email message to Trash (Gmail/Outlook only, not Slack) — recoverable via POST /messages/{id}/restore
 */
export const useDeleteMessage = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMessage>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteMessage>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteMessageMutationOptions(options));
    }

export const getRestoreMessageUrl = (id: string,) => {




  return `/api/messages/${id}/restore`
}

/**
 * @summary Restore a message out of Trash — pushes a real un-delete to Gmail/Outlook (best-effort) and clears the local deletedAt
 */
export const restoreMessage = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<UnifiedMessage> => {

  return customFetch<UnifiedMessage>(getRestoreMessageUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRestoreMessageMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof restoreMessage>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof restoreMessage>>, TError,{id: string}, TContext> => {

const mutationKey = ['restoreMessage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof restoreMessage>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  restoreMessage(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RestoreMessageMutationResult = NonNullable<Awaited<ReturnType<typeof restoreMessage>>>

    export type RestoreMessageMutationError = ErrorType<ApiError>

    /**
 * @summary Restore a message out of Trash — pushes a real un-delete to Gmail/Outlook (best-effort) and clears the local deletedAt
 */
export const useRestoreMessage = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof restoreMessage>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof restoreMessage>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getRestoreMessageMutationOptions(options));
    }

export const getFileMessageToFolderUrl = (id: string,) => {




  return `/api/messages/${id}/folder`
}

/**
 * @summary File a message into a specific Gmail label / Outlook folder (drag-and-drop) — the target folder's source must match the message's own source
 */
export const fileMessageToFolder = async (id: string,
    fileMessageToFolderRequest: FileMessageToFolderRequest, options?: Parameters<typeof customFetch>[1]): Promise<UnifiedMessage> => {

  return customFetch<UnifiedMessage>(getFileMessageToFolderUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(fileMessageToFolderRequest)
  }
);}





export const getFileMessageToFolderMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fileMessageToFolder>>, TError,{id: string;data: BodyType<FileMessageToFolderRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof fileMessageToFolder>>, TError,{id: string;data: BodyType<FileMessageToFolderRequest>}, TContext> => {

const mutationKey = ['fileMessageToFolder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof fileMessageToFolder>>, {id: string;data: BodyType<FileMessageToFolderRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  fileMessageToFolder(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FileMessageToFolderMutationResult = NonNullable<Awaited<ReturnType<typeof fileMessageToFolder>>>
    export type FileMessageToFolderMutationBody = BodyType<FileMessageToFolderRequest>
    export type FileMessageToFolderMutationError = ErrorType<ApiError>

    /**
 * @summary File a message into a specific Gmail label / Outlook folder (drag-and-drop) — the target folder's source must match the message's own source
 */
export const useFileMessageToFolder = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fileMessageToFolder>>, TError,{id: string;data: BodyType<FileMessageToFolderRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof fileMessageToFolder>>,
        TError,
        {id: string;data: BodyType<FileMessageToFolderRequest>},
        TContext
      > => {
      return useMutation(getFileMessageToFolderMutationOptions(options));
    }

export const getSendNativeChatMessageUrl = () => {




  return `/api/messages/native-reply`
}

/**
 * @summary Post a message into a native chat channel (baked into Assistio, not an external provider)
 */
export const sendNativeChatMessage = async (nativeReplyRequest: NativeReplyRequest, options?: Parameters<typeof customFetch>[1]): Promise<SendNativeChatMessage200> => {

  return customFetch<SendNativeChatMessage200>(getSendNativeChatMessageUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(nativeReplyRequest)
  }
);}





export const getSendNativeChatMessageMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendNativeChatMessage>>, TError,{data: BodyType<NativeReplyRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof sendNativeChatMessage>>, TError,{data: BodyType<NativeReplyRequest>}, TContext> => {

const mutationKey = ['sendNativeChatMessage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendNativeChatMessage>>, {data: BodyType<NativeReplyRequest>}> = (props) => {
          const {data} = props ?? {};

          return  sendNativeChatMessage(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendNativeChatMessageMutationResult = NonNullable<Awaited<ReturnType<typeof sendNativeChatMessage>>>
    export type SendNativeChatMessageMutationBody = BodyType<NativeReplyRequest>
    export type SendNativeChatMessageMutationError = ErrorType<ApiError>

    /**
 * @summary Post a message into a native chat channel (baked into Assistio, not an external provider)
 */
export const useSendNativeChatMessage = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendNativeChatMessage>>, TError,{data: BodyType<NativeReplyRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendNativeChatMessage>>,
        TError,
        {data: BodyType<NativeReplyRequest>},
        TContext
      > => {
      return useMutation(getSendNativeChatMessageMutationOptions(options));
    }

export const getGetMessageAttachmentUrl = (id: string,
    attachmentId: string,) => {




  return `/api/messages/${id}/attachments/${attachmentId}`
}

/**
 * @summary Proxy-fetch an attachment's bytes live from Gmail/Outlook — never stored locally
 */
export const getMessageAttachment = async (id: string,
    attachmentId: string, options?: Parameters<typeof customFetch>[1]): Promise<Blob> => {

  return customFetch<Blob>(getGetMessageAttachmentUrl(id,attachmentId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMessageAttachmentQueryKey = (id: string,
    attachmentId: string,) => {
    return [
    `/api/messages/${id}/attachments/${attachmentId}`
    ] as const;
    }


export const getGetMessageAttachmentQueryOptions = <TData = Awaited<ReturnType<typeof getMessageAttachment>>, TError = ErrorType<ApiError>>(id: string,
    attachmentId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMessageAttachment>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMessageAttachmentQueryKey(id,attachmentId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMessageAttachment>>> = ({ signal }) => getMessageAttachment(id,attachmentId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && attachmentId !== null && attachmentId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMessageAttachment>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMessageAttachmentQueryResult = NonNullable<Awaited<ReturnType<typeof getMessageAttachment>>>
export type GetMessageAttachmentQueryError = ErrorType<ApiError>


/**
 * @summary Proxy-fetch an attachment's bytes live from Gmail/Outlook — never stored locally
 */

export function useGetMessageAttachment<TData = Awaited<ReturnType<typeof getMessageAttachment>>, TError = ErrorType<ApiError>>(
 id: string,
    attachmentId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMessageAttachment>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMessageAttachmentQueryOptions(id,attachmentId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getReplyToMessageUrl = (id: string,) => {




  return `/api/messages/${id}/reply`
}

/**
 * @summary Reply to a Gmail or Outlook message
 */
export const replyToMessage = async (id: string,
    emailReplyBody: EmailReplyBody, options?: Parameters<typeof customFetch>[1]): Promise<OkResult> => {
    const formData = new FormData();
formData.append(`body`, emailReplyBody.body);
if(emailReplyBody.replyAll !== undefined) {
 formData.append(`replyAll`, emailReplyBody.replyAll.toString())
 }
if(emailReplyBody.attachments !== undefined) {
 emailReplyBody.attachments.forEach(value => formData.append(`attachments`, value));
 }

  return customFetch<OkResult>(getReplyToMessageUrl(id),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getReplyToMessageMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replyToMessage>>, TError,{id: string;data: BodyType<EmailReplyBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof replyToMessage>>, TError,{id: string;data: BodyType<EmailReplyBody>}, TContext> => {

const mutationKey = ['replyToMessage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof replyToMessage>>, {id: string;data: BodyType<EmailReplyBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  replyToMessage(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReplyToMessageMutationResult = NonNullable<Awaited<ReturnType<typeof replyToMessage>>>
    export type ReplyToMessageMutationBody = BodyType<EmailReplyBody>
    export type ReplyToMessageMutationError = ErrorType<ApiError>

    /**
 * @summary Reply to a Gmail or Outlook message
 */
export const useReplyToMessage = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replyToMessage>>, TError,{id: string;data: BodyType<EmailReplyBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof replyToMessage>>,
        TError,
        {id: string;data: BodyType<EmailReplyBody>},
        TContext
      > => {
      return useMutation(getReplyToMessageMutationOptions(options));
    }

export const getForwardMessageUrl = (id: string,) => {




  return `/api/messages/${id}/forward`
}

/**
 * @summary Forward a Gmail or Outlook message, carrying its own attachments along unless explicitly removed
 */
export const forwardMessage = async (id: string,
    forwardBody: ForwardBody, options?: Parameters<typeof customFetch>[1]): Promise<OkResult> => {
    const formData = new FormData();
formData.append(`to`, forwardBody.to);
if(forwardBody.comment !== undefined && forwardBody.comment !== null) {
 formData.append(`comment`, forwardBody.comment);
 }
if(forwardBody.keepAttachmentIds !== undefined) {
 forwardBody.keepAttachmentIds.forEach(value => formData.append(`keepAttachmentIds`, value));
 }
if(forwardBody.attachments !== undefined) {
 forwardBody.attachments.forEach(value => formData.append(`attachments`, value));
 }

  return customFetch<OkResult>(getForwardMessageUrl(id),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getForwardMessageMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof forwardMessage>>, TError,{id: string;data: BodyType<ForwardBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof forwardMessage>>, TError,{id: string;data: BodyType<ForwardBody>}, TContext> => {

const mutationKey = ['forwardMessage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof forwardMessage>>, {id: string;data: BodyType<ForwardBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  forwardMessage(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ForwardMessageMutationResult = NonNullable<Awaited<ReturnType<typeof forwardMessage>>>
    export type ForwardMessageMutationBody = BodyType<ForwardBody>
    export type ForwardMessageMutationError = ErrorType<ApiError>

    /**
 * @summary Forward a Gmail or Outlook message, carrying its own attachments along unless explicitly removed
 */
export const useForwardMessage = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof forwardMessage>>, TError,{id: string;data: BodyType<ForwardBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof forwardMessage>>,
        TError,
        {id: string;data: BodyType<ForwardBody>},
        TContext
      > => {
      return useMutation(getForwardMessageMutationOptions(options));
    }

export const getRespondToInviteUrl = (id: string,) => {




  return `/api/messages/${id}/respond-invite`
}

/**
 * @summary Accept, decline, or tentatively accept a meeting-invite message (Gmail or Outlook)
 */
export const respondToInvite = async (id: string,
    respondInviteBody: RespondInviteBody, options?: Parameters<typeof customFetch>[1]): Promise<OkResult> => {

  return customFetch<OkResult>(getRespondToInviteUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(respondInviteBody)
  }
);}





export const getRespondToInviteMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof respondToInvite>>, TError,{id: string;data: BodyType<RespondInviteBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof respondToInvite>>, TError,{id: string;data: BodyType<RespondInviteBody>}, TContext> => {

const mutationKey = ['respondToInvite'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof respondToInvite>>, {id: string;data: BodyType<RespondInviteBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  respondToInvite(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RespondToInviteMutationResult = NonNullable<Awaited<ReturnType<typeof respondToInvite>>>
    export type RespondToInviteMutationBody = BodyType<RespondInviteBody>
    export type RespondToInviteMutationError = ErrorType<ApiError>

    /**
 * @summary Accept, decline, or tentatively accept a meeting-invite message (Gmail or Outlook)
 */
export const useRespondToInvite = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof respondToInvite>>, TError,{id: string;data: BodyType<RespondInviteBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof respondToInvite>>,
        TError,
        {id: string;data: BodyType<RespondInviteBody>},
        TContext
      > => {
      return useMutation(getRespondToInviteMutationOptions(options));
    }

export const getComposeMessageUrl = () => {




  return `/api/messages/compose`
}

/**
 * @summary Send a brand-new message (not a reply) via Gmail, Outlook, or Slack, and file a copy like a received message
 */
export const composeMessage = async (composeBody: ComposeBody, options?: Parameters<typeof customFetch>[1]): Promise<UnifiedMessage> => {
    const formData = new FormData();
formData.append(`provider`, composeBody.provider);
formData.append(`to`, composeBody.to);
if(composeBody.toName !== undefined && composeBody.toName !== null) {
 formData.append(`toName`, composeBody.toName);
 }
if(composeBody.kind !== undefined && composeBody.kind !== null) {
 formData.append(`kind`, composeBody.kind);
 }
if(composeBody.teamId !== undefined && composeBody.teamId !== null) {
 formData.append(`teamId`, composeBody.teamId);
 }
if(composeBody.subject !== undefined && composeBody.subject !== null) {
 formData.append(`subject`, composeBody.subject);
 }
if(composeBody.cc !== undefined && composeBody.cc !== null) {
 composeBody.cc.forEach(value => formData.append(`cc`, value));
 }
if(composeBody.bcc !== undefined && composeBody.bcc !== null) {
 composeBody.bcc.forEach(value => formData.append(`bcc`, value));
 }
formData.append(`body`, composeBody.body);
if(composeBody.draftId !== undefined && composeBody.draftId !== null) {
 formData.append(`draftId`, composeBody.draftId.toString())
 }
if(composeBody.attachments !== undefined) {
 composeBody.attachments.forEach(value => formData.append(`attachments`, value));
 }

  return customFetch<UnifiedMessage>(getComposeMessageUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getComposeMessageMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof composeMessage>>, TError,{data: BodyType<ComposeBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof composeMessage>>, TError,{data: BodyType<ComposeBody>}, TContext> => {

const mutationKey = ['composeMessage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof composeMessage>>, {data: BodyType<ComposeBody>}> = (props) => {
          const {data} = props ?? {};

          return  composeMessage(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ComposeMessageMutationResult = NonNullable<Awaited<ReturnType<typeof composeMessage>>>
    export type ComposeMessageMutationBody = BodyType<ComposeBody>
    export type ComposeMessageMutationError = ErrorType<ApiError>

    /**
 * @summary Send a brand-new message (not a reply) via Gmail, Outlook, or Slack, and file a copy like a received message
 */
export const useComposeMessage = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof composeMessage>>, TError,{data: BodyType<ComposeBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof composeMessage>>,
        TError,
        {data: BodyType<ComposeBody>},
        TContext
      > => {
      return useMutation(getComposeMessageMutationOptions(options));
    }

export const getGetFoldersUrl = () => {




  return `/api/folders`
}

/**
 * @summary List all auto-organized folders (sender domains + Slack channels/DMs)
 */
export const getFolders = async ( options?: Parameters<typeof customFetch>[1]): Promise<Folder[]> => {

  return customFetch<Folder[]>(getGetFoldersUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetFoldersQueryKey = () => {
    return [
    `/api/folders`
    ] as const;
    }


export const getGetFoldersQueryOptions = <TData = Awaited<ReturnType<typeof getFolders>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getFolders>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFoldersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFolders>>> = ({ signal }) => getFolders({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFolders>>, TError, TData> & { queryKey: QueryKey }
}

export type GetFoldersQueryResult = NonNullable<Awaited<ReturnType<typeof getFolders>>>
export type GetFoldersQueryError = ErrorType<unknown>


/**
 * @summary List all auto-organized folders (sender domains + Slack channels/DMs)
 */

export function useGetFolders<TData = Awaited<ReturnType<typeof getFolders>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getFolders>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetFoldersQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getDeleteFolderUrl = () => {




  return `/api/folders`
}

/**
 * @summary Permanently delete a folder — purges its cached messages and blocks future sync from re-adding matches
 */
export const deleteFolder = async (deleteFolderRequest: DeleteFolderRequest, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDeleteFolderUrl(),
  {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(deleteFolderRequest)
  }
);}





export const getDeleteFolderMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFolder>>, TError,{data: BodyType<DeleteFolderRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteFolder>>, TError,{data: BodyType<DeleteFolderRequest>}, TContext> => {

const mutationKey = ['deleteFolder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteFolder>>, {data: BodyType<DeleteFolderRequest>}> = (props) => {
          const {data} = props ?? {};

          return  deleteFolder(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteFolderMutationResult = NonNullable<Awaited<ReturnType<typeof deleteFolder>>>
    export type DeleteFolderMutationBody = BodyType<DeleteFolderRequest>
    export type DeleteFolderMutationError = ErrorType<ApiError>

    /**
 * @summary Permanently delete a folder — purges its cached messages and blocks future sync from re-adding matches
 */
export const useDeleteFolder = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFolder>>, TError,{data: BodyType<DeleteFolderRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteFolder>>,
        TError,
        {data: BodyType<DeleteFolderRequest>},
        TContext
      > => {
      return useMutation(getDeleteFolderMutationOptions(options));
    }

export const getRenameFolderUrl = () => {




  return `/api/folders/rename`
}

/**
 * @summary Set or clear a folder's custom display label
 */
export const renameFolder = async (renameFolderRequest: RenameFolderRequest, options?: Parameters<typeof customFetch>[1]): Promise<OkResult> => {

  return customFetch<OkResult>(getRenameFolderUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(renameFolderRequest)
  }
);}





export const getRenameFolderMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof renameFolder>>, TError,{data: BodyType<RenameFolderRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof renameFolder>>, TError,{data: BodyType<RenameFolderRequest>}, TContext> => {

const mutationKey = ['renameFolder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof renameFolder>>, {data: BodyType<RenameFolderRequest>}> = (props) => {
          const {data} = props ?? {};

          return  renameFolder(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RenameFolderMutationResult = NonNullable<Awaited<ReturnType<typeof renameFolder>>>
    export type RenameFolderMutationBody = BodyType<RenameFolderRequest>
    export type RenameFolderMutationError = ErrorType<ApiError>

    /**
 * @summary Set or clear a folder's custom display label
 */
export const useRenameFolder = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof renameFolder>>, TError,{data: BodyType<RenameFolderRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof renameFolder>>,
        TError,
        {data: BodyType<RenameFolderRequest>},
        TContext
      > => {
      return useMutation(getRenameFolderMutationOptions(options));
    }

export const getReorderFoldersUrl = () => {




  return `/api/folders/order`
}

/**
 * @summary Persist a manual display order for a set of folders (e.g. after drag-and-drop)
 */
export const reorderFolders = async (reorderFoldersRequest: ReorderFoldersRequest, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getReorderFoldersUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(reorderFoldersRequest)
  }
);}





export const getReorderFoldersMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reorderFolders>>, TError,{data: BodyType<ReorderFoldersRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reorderFolders>>, TError,{data: BodyType<ReorderFoldersRequest>}, TContext> => {

const mutationKey = ['reorderFolders'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reorderFolders>>, {data: BodyType<ReorderFoldersRequest>}> = (props) => {
          const {data} = props ?? {};

          return  reorderFolders(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReorderFoldersMutationResult = NonNullable<Awaited<ReturnType<typeof reorderFolders>>>
    export type ReorderFoldersMutationBody = BodyType<ReorderFoldersRequest>
    export type ReorderFoldersMutationError = ErrorType<ApiError>

    /**
 * @summary Persist a manual display order for a set of folders (e.g. after drag-and-drop)
 */
export const useReorderFolders = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reorderFolders>>, TError,{data: BodyType<ReorderFoldersRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof reorderFolders>>,
        TError,
        {data: BodyType<ReorderFoldersRequest>},
        TContext
      > => {
      return useMutation(getReorderFoldersMutationOptions(options));
    }

export const getGetSlackChannelsUrl = () => {




  return `/api/slack/channels`
}

/**
 * @summary List available Slack channels
 */
export const getSlackChannels = async ( options?: Parameters<typeof customFetch>[1]): Promise<SlackChannel[]> => {

  return customFetch<SlackChannel[]>(getGetSlackChannelsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSlackChannelsQueryKey = () => {
    return [
    `/api/slack/channels`
    ] as const;
    }


export const getGetSlackChannelsQueryOptions = <TData = Awaited<ReturnType<typeof getSlackChannels>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSlackChannels>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSlackChannelsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSlackChannels>>> = ({ signal }) => getSlackChannels({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSlackChannels>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSlackChannelsQueryResult = NonNullable<Awaited<ReturnType<typeof getSlackChannels>>>
export type GetSlackChannelsQueryError = ErrorType<unknown>


/**
 * @summary List available Slack channels
 */

export function useGetSlackChannels<TData = Awaited<ReturnType<typeof getSlackChannels>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSlackChannels>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSlackChannelsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetTeamsChatsUrl = () => {




  return `/api/teams/chats`
}

/**
 * @summary List the connected account's Teams 1:1/group chats
 */
export const getTeamsChats = async ( options?: Parameters<typeof customFetch>[1]): Promise<TeamsChat[]> => {

  return customFetch<TeamsChat[]>(getGetTeamsChatsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTeamsChatsQueryKey = () => {
    return [
    `/api/teams/chats`
    ] as const;
    }


export const getGetTeamsChatsQueryOptions = <TData = Awaited<ReturnType<typeof getTeamsChats>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTeamsChats>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTeamsChatsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeamsChats>>> = ({ signal }) => getTeamsChats({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTeamsChats>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTeamsChatsQueryResult = NonNullable<Awaited<ReturnType<typeof getTeamsChats>>>
export type GetTeamsChatsQueryError = ErrorType<unknown>


/**
 * @summary List the connected account's Teams 1:1/group chats
 */

export function useGetTeamsChats<TData = Awaited<ReturnType<typeof getTeamsChats>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTeamsChats>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTeamsChatsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetJoinedTeamsListUrl = () => {




  return `/api/teams/teams`
}

/**
 * @summary List the Microsoft Teams the connected account has joined
 */
export const getJoinedTeamsList = async ( options?: Parameters<typeof customFetch>[1]): Promise<TeamsTeam[]> => {

  return customFetch<TeamsTeam[]>(getGetJoinedTeamsListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetJoinedTeamsListQueryKey = () => {
    return [
    `/api/teams/teams`
    ] as const;
    }


export const getGetJoinedTeamsListQueryOptions = <TData = Awaited<ReturnType<typeof getJoinedTeamsList>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getJoinedTeamsList>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetJoinedTeamsListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getJoinedTeamsList>>> = ({ signal }) => getJoinedTeamsList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getJoinedTeamsList>>, TError, TData> & { queryKey: QueryKey }
}

export type GetJoinedTeamsListQueryResult = NonNullable<Awaited<ReturnType<typeof getJoinedTeamsList>>>
export type GetJoinedTeamsListQueryError = ErrorType<unknown>


/**
 * @summary List the Microsoft Teams the connected account has joined
 */

export function useGetJoinedTeamsList<TData = Awaited<ReturnType<typeof getJoinedTeamsList>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getJoinedTeamsList>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetJoinedTeamsListQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetTeamsChannelsUrl = (teamId: string,) => {




  return `/api/teams/teams/${teamId}/channels`
}

/**
 * @summary List a Team's channels
 */
export const getTeamsChannels = async (teamId: string, options?: Parameters<typeof customFetch>[1]): Promise<TeamsChannel[]> => {

  return customFetch<TeamsChannel[]>(getGetTeamsChannelsUrl(teamId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTeamsChannelsQueryKey = (teamId: string,) => {
    return [
    `/api/teams/teams/${teamId}/channels`
    ] as const;
    }


export const getGetTeamsChannelsQueryOptions = <TData = Awaited<ReturnType<typeof getTeamsChannels>>, TError = ErrorType<unknown>>(teamId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTeamsChannels>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTeamsChannelsQueryKey(teamId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeamsChannels>>> = ({ signal }) => getTeamsChannels(teamId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTeamsChannels>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTeamsChannelsQueryResult = NonNullable<Awaited<ReturnType<typeof getTeamsChannels>>>
export type GetTeamsChannelsQueryError = ErrorType<unknown>


/**
 * @summary List a Team's channels
 */

export function useGetTeamsChannels<TData = Awaited<ReturnType<typeof getTeamsChannels>>, TError = ErrorType<unknown>>(
 teamId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTeamsChannels>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTeamsChannelsQueryOptions(teamId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetPresenceUrl = (params: GetPresenceParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/presence?${stringifiedParams}` : `/api/presence`
}

/**
 * @summary Batch presence for a set of Slack/Teams users
 */
export const getPresence = async (params: GetPresenceParams, options?: Parameters<typeof customFetch>[1]): Promise<PresenceMap> => {

  return customFetch<PresenceMap>(getGetPresenceUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPresenceQueryKey = (params?: GetPresenceParams,) => {
    return [
    `/api/presence`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPresenceQueryOptions = <TData = Awaited<ReturnType<typeof getPresence>>, TError = ErrorType<unknown>>(params: GetPresenceParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPresence>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPresenceQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPresence>>> = ({ signal }) => getPresence(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPresence>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPresenceQueryResult = NonNullable<Awaited<ReturnType<typeof getPresence>>>
export type GetPresenceQueryError = ErrorType<unknown>


/**
 * @summary Batch presence for a set of Slack/Teams users
 */

export function useGetPresence<TData = Awaited<ReturnType<typeof getPresence>>, TError = ErrorType<unknown>>(
 params: GetPresenceParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPresence>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPresenceQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetContactsUrl = (params: GetContactsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/contacts?${stringifiedParams}` : `/api/contacts`
}

/**
 * @summary Contact cards for a set of Slack/Teams users
 */
export const getContacts = async (params: GetContactsParams, options?: Parameters<typeof customFetch>[1]): Promise<ContactCard[]> => {

  return customFetch<ContactCard[]>(getGetContactsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetContactsQueryKey = (params?: GetContactsParams,) => {
    return [
    `/api/contacts`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetContactsQueryOptions = <TData = Awaited<ReturnType<typeof getContacts>>, TError = ErrorType<unknown>>(params: GetContactsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getContacts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetContactsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getContacts>>> = ({ signal }) => getContacts(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getContacts>>, TError, TData> & { queryKey: QueryKey }
}

export type GetContactsQueryResult = NonNullable<Awaited<ReturnType<typeof getContacts>>>
export type GetContactsQueryError = ErrorType<unknown>


/**
 * @summary Contact cards for a set of Slack/Teams users
 */

export function useGetContacts<TData = Awaited<ReturnType<typeof getContacts>>, TError = ErrorType<unknown>>(
 params: GetContactsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getContacts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetContactsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetSelfOutOfOfficeUrl = () => {




  return `/api/presence/self/out-of-office`
}

/**
 * @summary The signed-in account's own out-of-office (Teams auto-reply) setting
 */
export const getSelfOutOfOffice = async ( options?: Parameters<typeof customFetch>[1]): Promise<OutOfOffice> => {

  return customFetch<OutOfOffice>(getGetSelfOutOfOfficeUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSelfOutOfOfficeQueryKey = () => {
    return [
    `/api/presence/self/out-of-office`
    ] as const;
    }


export const getGetSelfOutOfOfficeQueryOptions = <TData = Awaited<ReturnType<typeof getSelfOutOfOffice>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSelfOutOfOffice>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSelfOutOfOfficeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSelfOutOfOffice>>> = ({ signal }) => getSelfOutOfOffice({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSelfOutOfOffice>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSelfOutOfOfficeQueryResult = NonNullable<Awaited<ReturnType<typeof getSelfOutOfOffice>>>
export type GetSelfOutOfOfficeQueryError = ErrorType<unknown>


/**
 * @summary The signed-in account's own out-of-office (Teams auto-reply) setting
 */

export function useGetSelfOutOfOffice<TData = Awaited<ReturnType<typeof getSelfOutOfOffice>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSelfOutOfOffice>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSelfOutOfOfficeQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetContactAvatarUrl = (source: 'slack' | 'teams',
    id: string,) => {




  return `/api/contacts/${source}/${id}/avatar`
}

/**
 * @summary Proxy a contact's avatar image bytes through our origin
 */
export const getContactAvatar = async (source: 'slack' | 'teams',
    id: string, options?: Parameters<typeof customFetch>[1]): Promise<Blob> => {

  return customFetch<Blob>(getGetContactAvatarUrl(source,id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetContactAvatarQueryKey = (source: 'slack' | 'teams',
    id: string,) => {
    return [
    `/api/contacts/${source}/${id}/avatar`
    ] as const;
    }


export const getGetContactAvatarQueryOptions = <TData = Awaited<ReturnType<typeof getContactAvatar>>, TError = ErrorType<void>>(source: 'slack' | 'teams',
    id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getContactAvatar>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetContactAvatarQueryKey(source,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getContactAvatar>>> = ({ signal }) => getContactAvatar(source,id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: source !== null && source !== undefined && id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getContactAvatar>>, TError, TData> & { queryKey: QueryKey }
}

export type GetContactAvatarQueryResult = NonNullable<Awaited<ReturnType<typeof getContactAvatar>>>
export type GetContactAvatarQueryError = ErrorType<void>


/**
 * @summary Proxy a contact's avatar image bytes through our origin
 */

export function useGetContactAvatar<TData = Awaited<ReturnType<typeof getContactAvatar>>, TError = ErrorType<void>>(
 source: 'slack' | 'teams',
    id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getContactAvatar>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetContactAvatarQueryOptions(source,id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetJiraPrioritiesUrl = () => {




  return `/api/jira/priorities`
}

/**
 * @summary Priority options available on the connected Jira site — used to constrain the priority picker for Jira-sourced tasks
 */
export const getJiraPriorities = async ( options?: Parameters<typeof customFetch>[1]): Promise<JiraPriority[]> => {

  return customFetch<JiraPriority[]>(getGetJiraPrioritiesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetJiraPrioritiesQueryKey = () => {
    return [
    `/api/jira/priorities`
    ] as const;
    }


export const getGetJiraPrioritiesQueryOptions = <TData = Awaited<ReturnType<typeof getJiraPriorities>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getJiraPriorities>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetJiraPrioritiesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getJiraPriorities>>> = ({ signal }) => getJiraPriorities({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getJiraPriorities>>, TError, TData> & { queryKey: QueryKey }
}

export type GetJiraPrioritiesQueryResult = NonNullable<Awaited<ReturnType<typeof getJiraPriorities>>>
export type GetJiraPrioritiesQueryError = ErrorType<unknown>


/**
 * @summary Priority options available on the connected Jira site — used to constrain the priority picker for Jira-sourced tasks
 */

export function useGetJiraPriorities<TData = Awaited<ReturnType<typeof getJiraPriorities>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getJiraPriorities>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetJiraPrioritiesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetJiraProjectsUrl = () => {




  return `/api/jira/projects`
}

/**
 * @summary Projects in the connected Jira site, plus the currently selected sync scope (null/empty = every project)
 */
export const getJiraProjects = async ( options?: Parameters<typeof customFetch>[1]): Promise<JiraProjectsResponse> => {

  return customFetch<JiraProjectsResponse>(getGetJiraProjectsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetJiraProjectsQueryKey = () => {
    return [
    `/api/jira/projects`
    ] as const;
    }


export const getGetJiraProjectsQueryOptions = <TData = Awaited<ReturnType<typeof getJiraProjects>>, TError = ErrorType<ApiError>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getJiraProjects>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetJiraProjectsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getJiraProjects>>> = ({ signal }) => getJiraProjects({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getJiraProjects>>, TError, TData> & { queryKey: QueryKey }
}

export type GetJiraProjectsQueryResult = NonNullable<Awaited<ReturnType<typeof getJiraProjects>>>
export type GetJiraProjectsQueryError = ErrorType<ApiError>


/**
 * @summary Projects in the connected Jira site, plus the currently selected sync scope (null/empty = every project)
 */

export function useGetJiraProjects<TData = Awaited<ReturnType<typeof getJiraProjects>>, TError = ErrorType<ApiError>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getJiraProjects>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetJiraProjectsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateJiraProjectSelectionUrl = () => {




  return `/api/jira/projects`
}

/**
 * @summary Set which Jira projects to sync — empty array reverts to every project
 */
export const updateJiraProjectSelection = async (updateProjectSelectionRequest: UpdateProjectSelectionRequest, options?: Parameters<typeof customFetch>[1]): Promise<JiraProjectsResponse> => {

  return customFetch<JiraProjectsResponse>(getUpdateJiraProjectSelectionUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateProjectSelectionRequest)
  }
);}





export const getUpdateJiraProjectSelectionMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateJiraProjectSelection>>, TError,{data: BodyType<UpdateProjectSelectionRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateJiraProjectSelection>>, TError,{data: BodyType<UpdateProjectSelectionRequest>}, TContext> => {

const mutationKey = ['updateJiraProjectSelection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateJiraProjectSelection>>, {data: BodyType<UpdateProjectSelectionRequest>}> = (props) => {
          const {data} = props ?? {};

          return  updateJiraProjectSelection(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateJiraProjectSelectionMutationResult = NonNullable<Awaited<ReturnType<typeof updateJiraProjectSelection>>>
    export type UpdateJiraProjectSelectionMutationBody = BodyType<UpdateProjectSelectionRequest>
    export type UpdateJiraProjectSelectionMutationError = ErrorType<ApiError>

    /**
 * @summary Set which Jira projects to sync — empty array reverts to every project
 */
export const useUpdateJiraProjectSelection = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateJiraProjectSelection>>, TError,{data: BodyType<UpdateProjectSelectionRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateJiraProjectSelection>>,
        TError,
        {data: BodyType<UpdateProjectSelectionRequest>},
        TContext
      > => {
      return useMutation(getUpdateJiraProjectSelectionMutationOptions(options));
    }

export const getGetAdoProjectsUrl = () => {




  return `/api/ado/projects`
}

/**
 * @summary Team projects in the connected Azure DevOps organization, plus the currently selected sync scope (null/empty = every project)
 */
export const getAdoProjects = async ( options?: Parameters<typeof customFetch>[1]): Promise<AdoProjectsResponse> => {

  return customFetch<AdoProjectsResponse>(getGetAdoProjectsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdoProjectsQueryKey = () => {
    return [
    `/api/ado/projects`
    ] as const;
    }


export const getGetAdoProjectsQueryOptions = <TData = Awaited<ReturnType<typeof getAdoProjects>>, TError = ErrorType<ApiError>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdoProjects>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdoProjectsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdoProjects>>> = ({ signal }) => getAdoProjects({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdoProjects>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdoProjectsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdoProjects>>>
export type GetAdoProjectsQueryError = ErrorType<ApiError>


/**
 * @summary Team projects in the connected Azure DevOps organization, plus the currently selected sync scope (null/empty = every project)
 */

export function useGetAdoProjects<TData = Awaited<ReturnType<typeof getAdoProjects>>, TError = ErrorType<ApiError>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdoProjects>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdoProjectsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateAdoProjectSelectionUrl = () => {




  return `/api/ado/projects`
}

/**
 * @summary Set which Azure DevOps team projects to sync — empty array reverts to every project
 */
export const updateAdoProjectSelection = async (updateProjectSelectionRequest: UpdateProjectSelectionRequest, options?: Parameters<typeof customFetch>[1]): Promise<AdoProjectsResponse> => {

  return customFetch<AdoProjectsResponse>(getUpdateAdoProjectSelectionUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateProjectSelectionRequest)
  }
);}





export const getUpdateAdoProjectSelectionMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdoProjectSelection>>, TError,{data: BodyType<UpdateProjectSelectionRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAdoProjectSelection>>, TError,{data: BodyType<UpdateProjectSelectionRequest>}, TContext> => {

const mutationKey = ['updateAdoProjectSelection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAdoProjectSelection>>, {data: BodyType<UpdateProjectSelectionRequest>}> = (props) => {
          const {data} = props ?? {};

          return  updateAdoProjectSelection(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAdoProjectSelectionMutationResult = NonNullable<Awaited<ReturnType<typeof updateAdoProjectSelection>>>
    export type UpdateAdoProjectSelectionMutationBody = BodyType<UpdateProjectSelectionRequest>
    export type UpdateAdoProjectSelectionMutationError = ErrorType<ApiError>

    /**
 * @summary Set which Azure DevOps team projects to sync — empty array reverts to every project
 */
export const useUpdateAdoProjectSelection = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdoProjectSelection>>, TError,{data: BodyType<UpdateProjectSelectionRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateAdoProjectSelection>>,
        TError,
        {data: BodyType<UpdateProjectSelectionRequest>},
        TContext
      > => {
      return useMutation(getUpdateAdoProjectSelectionMutationOptions(options));
    }

export const getGetJiraIssueDetailUrl = (key: string,) => {




  return `/api/jira/issues/${key}`
}

/**
 * @summary Live-fetch full ticket detail (description, reporter, dates, labels, etc.) for the full-window view
 */
export const getJiraIssueDetail = async (key: string, options?: Parameters<typeof customFetch>[1]): Promise<JiraIssueDetail> => {

  return customFetch<JiraIssueDetail>(getGetJiraIssueDetailUrl(key),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetJiraIssueDetailQueryKey = (key: string,) => {
    return [
    `/api/jira/issues/${key}`
    ] as const;
    }


export const getGetJiraIssueDetailQueryOptions = <TData = Awaited<ReturnType<typeof getJiraIssueDetail>>, TError = ErrorType<ApiError>>(key: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getJiraIssueDetail>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetJiraIssueDetailQueryKey(key);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getJiraIssueDetail>>> = ({ signal }) => getJiraIssueDetail(key, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: key !== null && key !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getJiraIssueDetail>>, TError, TData> & { queryKey: QueryKey }
}

export type GetJiraIssueDetailQueryResult = NonNullable<Awaited<ReturnType<typeof getJiraIssueDetail>>>
export type GetJiraIssueDetailQueryError = ErrorType<ApiError>


/**
 * @summary Live-fetch full ticket detail (description, reporter, dates, labels, etc.) for the full-window view
 */

export function useGetJiraIssueDetail<TData = Awaited<ReturnType<typeof getJiraIssueDetail>>, TError = ErrorType<ApiError>>(
 key: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getJiraIssueDetail>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetJiraIssueDetailQueryOptions(key,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getPostJiraCommentUrl = (key: string,) => {




  return `/api/jira/issues/${key}/comment`
}

/**
 * @summary Post a comment on a Jira ticket
 */
export const postJiraComment = async (key: string,
    replyBody: ReplyBody, options?: Parameters<typeof customFetch>[1]): Promise<UnifiedMessage> => {

  return customFetch<UnifiedMessage>(getPostJiraCommentUrl(key),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(replyBody)
  }
);}





export const getPostJiraCommentMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postJiraComment>>, TError,{key: string;data: BodyType<ReplyBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postJiraComment>>, TError,{key: string;data: BodyType<ReplyBody>}, TContext> => {

const mutationKey = ['postJiraComment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postJiraComment>>, {key: string;data: BodyType<ReplyBody>}> = (props) => {
          const {key,data} = props ?? {};

          return  postJiraComment(key,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostJiraCommentMutationResult = NonNullable<Awaited<ReturnType<typeof postJiraComment>>>
    export type PostJiraCommentMutationBody = BodyType<ReplyBody>
    export type PostJiraCommentMutationError = ErrorType<ApiError>

    /**
 * @summary Post a comment on a Jira ticket
 */
export const usePostJiraComment = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postJiraComment>>, TError,{key: string;data: BodyType<ReplyBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postJiraComment>>,
        TError,
        {key: string;data: BodyType<ReplyBody>},
        TContext
      > => {
      return useMutation(getPostJiraCommentMutationOptions(options));
    }

export const getGetDocsUrl = () => {




  return `/api/docs`
}

/**
 * @summary List every doc (summary only, no content — keeps the list view light)
 */
export const getDocs = async ( options?: Parameters<typeof customFetch>[1]): Promise<DocSummary[]> => {

  return customFetch<DocSummary[]>(getGetDocsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDocsQueryKey = () => {
    return [
    `/api/docs`
    ] as const;
    }


export const getGetDocsQueryOptions = <TData = Awaited<ReturnType<typeof getDocs>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDocs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDocsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDocs>>> = ({ signal }) => getDocs({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDocs>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDocsQueryResult = NonNullable<Awaited<ReturnType<typeof getDocs>>>
export type GetDocsQueryError = ErrorType<unknown>


/**
 * @summary List every doc (summary only, no content — keeps the list view light)
 */

export function useGetDocs<TData = Awaited<ReturnType<typeof getDocs>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDocs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDocsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateDocUrl = () => {




  return `/api/docs`
}

/**
 * @summary Create a new doc
 */
export const createDoc = async (createDocRequest: CreateDocRequest, options?: Parameters<typeof customFetch>[1]): Promise<Doc> => {

  return customFetch<Doc>(getCreateDocUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createDocRequest)
  }
);}





export const getCreateDocMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDoc>>, TError,{data: BodyType<CreateDocRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createDoc>>, TError,{data: BodyType<CreateDocRequest>}, TContext> => {

const mutationKey = ['createDoc'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createDoc>>, {data: BodyType<CreateDocRequest>}> = (props) => {
          const {data} = props ?? {};

          return  createDoc(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateDocMutationResult = NonNullable<Awaited<ReturnType<typeof createDoc>>>
    export type CreateDocMutationBody = BodyType<CreateDocRequest>
    export type CreateDocMutationError = ErrorType<unknown>

    /**
 * @summary Create a new doc
 */
export const useCreateDoc = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDoc>>, TError,{data: BodyType<CreateDocRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createDoc>>,
        TError,
        {data: BodyType<CreateDocRequest>},
        TContext
      > => {
      return useMutation(getCreateDocMutationOptions(options));
    }

export const getGetDocUrl = (id: number,) => {




  return `/api/docs/${id}`
}

/**
 * @summary Get a single doc, including its content
 */
export const getDoc = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<Doc> => {

  return customFetch<Doc>(getGetDocUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDocQueryKey = (id: number,) => {
    return [
    `/api/docs/${id}`
    ] as const;
    }


export const getGetDocQueryOptions = <TData = Awaited<ReturnType<typeof getDoc>>, TError = ErrorType<ApiError>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDoc>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDocQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDoc>>> = ({ signal }) => getDoc(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDoc>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDocQueryResult = NonNullable<Awaited<ReturnType<typeof getDoc>>>
export type GetDocQueryError = ErrorType<ApiError>


/**
 * @summary Get a single doc, including its content
 */

export function useGetDoc<TData = Awaited<ReturnType<typeof getDoc>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDoc>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDocQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateDocUrl = (id: number,) => {




  return `/api/docs/${id}`
}

/**
 * @summary Partially update a doc's title and/or content
 */
export const updateDoc = async (id: number,
    updateDocRequest: UpdateDocRequest, options?: Parameters<typeof customFetch>[1]): Promise<Doc> => {

  return customFetch<Doc>(getUpdateDocUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateDocRequest)
  }
);}





export const getUpdateDocMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDoc>>, TError,{id: number;data: BodyType<UpdateDocRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateDoc>>, TError,{id: number;data: BodyType<UpdateDocRequest>}, TContext> => {

const mutationKey = ['updateDoc'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDoc>>, {id: number;data: BodyType<UpdateDocRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateDoc(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateDocMutationResult = NonNullable<Awaited<ReturnType<typeof updateDoc>>>
    export type UpdateDocMutationBody = BodyType<UpdateDocRequest>
    export type UpdateDocMutationError = ErrorType<ApiError>

    /**
 * @summary Partially update a doc's title and/or content
 */
export const useUpdateDoc = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDoc>>, TError,{id: number;data: BodyType<UpdateDocRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateDoc>>,
        TError,
        {id: number;data: BodyType<UpdateDocRequest>},
        TContext
      > => {
      return useMutation(getUpdateDocMutationOptions(options));
    }

export const getDeleteDocUrl = (id: number,) => {




  return `/api/docs/${id}`
}

/**
 * @summary Delete a doc
 */
export const deleteDoc = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDeleteDocUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteDocMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDoc>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteDoc>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteDoc'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteDoc>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteDoc(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteDocMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDoc>>>

    export type DeleteDocMutationError = ErrorType<ApiError>

    /**
 * @summary Delete a doc
 */
export const useDeleteDoc = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDoc>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteDoc>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteDocMutationOptions(options));
    }

export const getGetDraftsUrl = () => {




  return `/api/drafts`
}

/**
 * @summary List every autosaved draft, most recently updated first
 */
export const getDrafts = async ( options?: Parameters<typeof customFetch>[1]): Promise<Draft[]> => {

  return customFetch<Draft[]>(getGetDraftsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDraftsQueryKey = () => {
    return [
    `/api/drafts`
    ] as const;
    }


export const getGetDraftsQueryOptions = <TData = Awaited<ReturnType<typeof getDrafts>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDrafts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDraftsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDrafts>>> = ({ signal }) => getDrafts({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDrafts>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDraftsQueryResult = NonNullable<Awaited<ReturnType<typeof getDrafts>>>
export type GetDraftsQueryError = ErrorType<unknown>


/**
 * @summary List every autosaved draft, most recently updated first
 */

export function useGetDrafts<TData = Awaited<ReturnType<typeof getDrafts>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDrafts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDraftsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateDraftUrl = () => {




  return `/api/drafts`
}

/**
 * @summary Create a new draft — called once, the first time a new compose window has meaningful content to save
 */
export const createDraft = async (createDraftRequest: CreateDraftRequest, options?: Parameters<typeof customFetch>[1]): Promise<Draft> => {

  return customFetch<Draft>(getCreateDraftUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createDraftRequest)
  }
);}





export const getCreateDraftMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDraft>>, TError,{data: BodyType<CreateDraftRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createDraft>>, TError,{data: BodyType<CreateDraftRequest>}, TContext> => {

const mutationKey = ['createDraft'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createDraft>>, {data: BodyType<CreateDraftRequest>}> = (props) => {
          const {data} = props ?? {};

          return  createDraft(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateDraftMutationResult = NonNullable<Awaited<ReturnType<typeof createDraft>>>
    export type CreateDraftMutationBody = BodyType<CreateDraftRequest>
    export type CreateDraftMutationError = ErrorType<unknown>

    /**
 * @summary Create a new draft — called once, the first time a new compose window has meaningful content to save
 */
export const useCreateDraft = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDraft>>, TError,{data: BodyType<CreateDraftRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createDraft>>,
        TError,
        {data: BodyType<CreateDraftRequest>},
        TContext
      > => {
      return useMutation(getCreateDraftMutationOptions(options));
    }

export const getGetDraftUrl = (id: number,) => {




  return `/api/drafts/${id}`
}

/**
 * @summary Get a single draft — used to reopen it in ComposeModal
 */
export const getDraft = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<Draft> => {

  return customFetch<Draft>(getGetDraftUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDraftQueryKey = (id: number,) => {
    return [
    `/api/drafts/${id}`
    ] as const;
    }


export const getGetDraftQueryOptions = <TData = Awaited<ReturnType<typeof getDraft>>, TError = ErrorType<ApiError>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDraft>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDraftQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDraft>>> = ({ signal }) => getDraft(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDraft>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDraftQueryResult = NonNullable<Awaited<ReturnType<typeof getDraft>>>
export type GetDraftQueryError = ErrorType<ApiError>


/**
 * @summary Get a single draft — used to reopen it in ComposeModal
 */

export function useGetDraft<TData = Awaited<ReturnType<typeof getDraft>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDraft>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDraftQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateDraftUrl = (id: number,) => {




  return `/api/drafts/${id}`
}

/**
 * @summary Autosave the current compose fields onto an existing draft
 */
export const updateDraft = async (id: number,
    updateDraftRequest: UpdateDraftRequest, options?: Parameters<typeof customFetch>[1]): Promise<Draft> => {

  return customFetch<Draft>(getUpdateDraftUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateDraftRequest)
  }
);}





export const getUpdateDraftMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDraft>>, TError,{id: number;data: BodyType<UpdateDraftRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateDraft>>, TError,{id: number;data: BodyType<UpdateDraftRequest>}, TContext> => {

const mutationKey = ['updateDraft'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDraft>>, {id: number;data: BodyType<UpdateDraftRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateDraft(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateDraftMutationResult = NonNullable<Awaited<ReturnType<typeof updateDraft>>>
    export type UpdateDraftMutationBody = BodyType<UpdateDraftRequest>
    export type UpdateDraftMutationError = ErrorType<ApiError>

    /**
 * @summary Autosave the current compose fields onto an existing draft
 */
export const useUpdateDraft = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDraft>>, TError,{id: number;data: BodyType<UpdateDraftRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateDraft>>,
        TError,
        {id: number;data: BodyType<UpdateDraftRequest>},
        TContext
      > => {
      return useMutation(getUpdateDraftMutationOptions(options));
    }

export const getDeleteDraftUrl = (id: number,) => {




  return `/api/drafts/${id}`
}

/**
 * @summary Discard a draft
 */
export const deleteDraft = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDeleteDraftUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteDraftMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDraft>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteDraft>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteDraft'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteDraft>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteDraft(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteDraftMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDraft>>>

    export type DeleteDraftMutationError = ErrorType<ApiError>

    /**
 * @summary Discard a draft
 */
export const useDeleteDraft = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDraft>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteDraft>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteDraftMutationOptions(options));
    }

export const getCreateListUrl = () => {




  return `/api/lists`
}

/**
 * @summary Create a new task list
 */
export const createList = async (createListRequest: CreateListRequest, options?: Parameters<typeof customFetch>[1]): Promise<List> => {

  return customFetch<List>(getCreateListUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createListRequest)
  }
);}





export const getCreateListMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createList>>, TError,{data: BodyType<CreateListRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createList>>, TError,{data: BodyType<CreateListRequest>}, TContext> => {

const mutationKey = ['createList'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createList>>, {data: BodyType<CreateListRequest>}> = (props) => {
          const {data} = props ?? {};

          return  createList(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateListMutationResult = NonNullable<Awaited<ReturnType<typeof createList>>>
    export type CreateListMutationBody = BodyType<CreateListRequest>
    export type CreateListMutationError = ErrorType<ApiError>

    /**
 * @summary Create a new task list
 */
export const useCreateList = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createList>>, TError,{data: BodyType<CreateListRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createList>>,
        TError,
        {data: BodyType<CreateListRequest>},
        TContext
      > => {
      return useMutation(getCreateListMutationOptions(options));
    }

export const getCreateChatChannelUrl = () => {




  return `/api/chat/channels`
}

/**
 * @summary Create (or idempotently reopen, by name) a native chat channel
 */
export const createChatChannel = async (createChatChannelRequest: CreateChatChannelRequest, options?: Parameters<typeof customFetch>[1]): Promise<ChatChannel> => {

  return customFetch<ChatChannel>(getCreateChatChannelUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createChatChannelRequest)
  }
);}





export const getCreateChatChannelMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createChatChannel>>, TError,{data: BodyType<CreateChatChannelRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createChatChannel>>, TError,{data: BodyType<CreateChatChannelRequest>}, TContext> => {

const mutationKey = ['createChatChannel'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createChatChannel>>, {data: BodyType<CreateChatChannelRequest>}> = (props) => {
          const {data} = props ?? {};

          return  createChatChannel(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateChatChannelMutationResult = NonNullable<Awaited<ReturnType<typeof createChatChannel>>>
    export type CreateChatChannelMutationBody = BodyType<CreateChatChannelRequest>
    export type CreateChatChannelMutationError = ErrorType<ApiError>

    /**
 * @summary Create (or idempotently reopen, by name) a native chat channel
 */
export const useCreateChatChannel = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createChatChannel>>, TError,{data: BodyType<CreateChatChannelRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createChatChannel>>,
        TError,
        {data: BodyType<CreateChatChannelRequest>},
        TContext
      > => {
      return useMutation(getCreateChatChannelMutationOptions(options));
    }

export const getUpdateListUrl = (id: number,) => {




  return `/api/lists/${id}`
}

/**
 * @summary Update a list's color
 */
export const updateList = async (id: number,
    updateListRequest: UpdateListRequest, options?: Parameters<typeof customFetch>[1]): Promise<List> => {

  return customFetch<List>(getUpdateListUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateListRequest)
  }
);}





export const getUpdateListMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateList>>, TError,{id: number;data: BodyType<UpdateListRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateList>>, TError,{id: number;data: BodyType<UpdateListRequest>}, TContext> => {

const mutationKey = ['updateList'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateList>>, {id: number;data: BodyType<UpdateListRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateList(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateListMutationResult = NonNullable<Awaited<ReturnType<typeof updateList>>>
    export type UpdateListMutationBody = BodyType<UpdateListRequest>
    export type UpdateListMutationError = ErrorType<ApiError>

    /**
 * @summary Update a list's color
 */
export const useUpdateList = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateList>>, TError,{id: number;data: BodyType<UpdateListRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateList>>,
        TError,
        {id: number;data: BodyType<UpdateListRequest>},
        TContext
      > => {
      return useMutation(getUpdateListMutationOptions(options));
    }

export const getDeleteListUrl = (id: number,) => {




  return `/api/lists/${id}`
}

/**
 * @summary Delete a list and cascade-delete its tasks
 */
export const deleteList = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDeleteListUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteListMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteList>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteList>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteList'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteList>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteList(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteListMutationResult = NonNullable<Awaited<ReturnType<typeof deleteList>>>

    export type DeleteListMutationError = ErrorType<ApiError>

    /**
 * @summary Delete a list and cascade-delete its tasks
 */
export const useDeleteList = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteList>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteList>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteListMutationOptions(options));
    }

export const getGetTasksUrl = () => {




  return `/api/tasks`
}

/**
 * @summary Get every task across every list
 */
export const getTasks = async ( options?: Parameters<typeof customFetch>[1]): Promise<Task[]> => {

  return customFetch<Task[]>(getGetTasksUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTasksQueryKey = () => {
    return [
    `/api/tasks`
    ] as const;
    }


export const getGetTasksQueryOptions = <TData = Awaited<ReturnType<typeof getTasks>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTasks>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTasksQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTasks>>> = ({ signal }) => getTasks({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTasks>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTasksQueryResult = NonNullable<Awaited<ReturnType<typeof getTasks>>>
export type GetTasksQueryError = ErrorType<unknown>


/**
 * @summary Get every task across every list
 */

export function useGetTasks<TData = Awaited<ReturnType<typeof getTasks>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTasks>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTasksQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateTaskUrl = () => {




  return `/api/tasks`
}

/**
 * @summary Create a task in a list
 */
export const createTask = async (createTaskRequest: CreateTaskRequest, options?: Parameters<typeof customFetch>[1]): Promise<Task> => {

  return customFetch<Task>(getCreateTaskUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createTaskRequest)
  }
);}





export const getCreateTaskMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTask>>, TError,{data: BodyType<CreateTaskRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTask>>, TError,{data: BodyType<CreateTaskRequest>}, TContext> => {

const mutationKey = ['createTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTask>>, {data: BodyType<CreateTaskRequest>}> = (props) => {
          const {data} = props ?? {};

          return  createTask(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTaskMutationResult = NonNullable<Awaited<ReturnType<typeof createTask>>>
    export type CreateTaskMutationBody = BodyType<CreateTaskRequest>
    export type CreateTaskMutationError = ErrorType<ApiError>

    /**
 * @summary Create a task in a list
 */
export const useCreateTask = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTask>>, TError,{data: BodyType<CreateTaskRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createTask>>,
        TError,
        {data: BodyType<CreateTaskRequest>},
        TContext
      > => {
      return useMutation(getCreateTaskMutationOptions(options));
    }

export const getUpdateTaskUrl = (id: number,) => {




  return `/api/tasks/${id}`
}

/**
 * @summary Partially update a task (title, description, status, priority, due date)
 */
export const updateTask = async (id: number,
    updateTaskRequest: UpdateTaskRequest, options?: Parameters<typeof customFetch>[1]): Promise<Task> => {

  return customFetch<Task>(getUpdateTaskUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateTaskRequest)
  }
);}





export const getUpdateTaskMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTask>>, TError,{id: number;data: BodyType<UpdateTaskRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTask>>, TError,{id: number;data: BodyType<UpdateTaskRequest>}, TContext> => {

const mutationKey = ['updateTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTask>>, {id: number;data: BodyType<UpdateTaskRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateTask(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTaskMutationResult = NonNullable<Awaited<ReturnType<typeof updateTask>>>
    export type UpdateTaskMutationBody = BodyType<UpdateTaskRequest>
    export type UpdateTaskMutationError = ErrorType<ApiError>

    /**
 * @summary Partially update a task (title, description, status, priority, due date)
 */
export const useUpdateTask = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTask>>, TError,{id: number;data: BodyType<UpdateTaskRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateTask>>,
        TError,
        {id: number;data: BodyType<UpdateTaskRequest>},
        TContext
      > => {
      return useMutation(getUpdateTaskMutationOptions(options));
    }

export const getDeleteTaskUrl = (id: number,) => {




  return `/api/tasks/${id}`
}

/**
 * @summary Delete a task
 */
export const deleteTask = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDeleteTaskUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteTaskMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTask>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTask>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTask>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteTask(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTaskMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTask>>>

    export type DeleteTaskMutationError = ErrorType<ApiError>

    /**
 * @summary Delete a task
 */
export const useDeleteTask = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTask>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteTask>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteTaskMutationOptions(options));
    }

export const getGetTaskSummaryUrl = (params?: GetTaskSummaryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/tasks/summary?${stringifiedParams}` : `/api/tasks/summary`
}

/**
 * @summary AI-generated briefing for a list (or every list, if listId is omitted) — overdue/stalled/blocked patterns, not just counts.
 */
export const getTaskSummary = async (params?: GetTaskSummaryParams, options?: Parameters<typeof customFetch>[1]): Promise<TaskSummary> => {

  return customFetch<TaskSummary>(getGetTaskSummaryUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTaskSummaryQueryKey = (params?: GetTaskSummaryParams,) => {
    return [
    `/api/tasks/summary`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetTaskSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getTaskSummary>>, TError = ErrorType<unknown>>(params?: GetTaskSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTaskSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTaskSummaryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTaskSummary>>> = ({ signal }) => getTaskSummary(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTaskSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTaskSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getTaskSummary>>>
export type GetTaskSummaryQueryError = ErrorType<unknown>


/**
 * @summary AI-generated briefing for a list (or every list, if listId is omitted) — overdue/stalled/blocked patterns, not just counts.
 */

export function useGetTaskSummary<TData = Awaited<ReturnType<typeof getTaskSummary>>, TError = ErrorType<unknown>>(
 params?: GetTaskSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTaskSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTaskSummaryQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getReorderTasksUrl = () => {




  return `/api/tasks/order`
}

/**
 * @summary Persist a manual display order for a set of top-level tasks (e.g. after drag-and-drop). Only meaningful in the ungrouped list view.
 */
export const reorderTasks = async (reorderTasksRequest: ReorderTasksRequest, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getReorderTasksUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(reorderTasksRequest)
  }
);}





export const getReorderTasksMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reorderTasks>>, TError,{data: BodyType<ReorderTasksRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reorderTasks>>, TError,{data: BodyType<ReorderTasksRequest>}, TContext> => {

const mutationKey = ['reorderTasks'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reorderTasks>>, {data: BodyType<ReorderTasksRequest>}> = (props) => {
          const {data} = props ?? {};

          return  reorderTasks(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReorderTasksMutationResult = NonNullable<Awaited<ReturnType<typeof reorderTasks>>>
    export type ReorderTasksMutationBody = BodyType<ReorderTasksRequest>
    export type ReorderTasksMutationError = ErrorType<ApiError>

    /**
 * @summary Persist a manual display order for a set of top-level tasks (e.g. after drag-and-drop). Only meaningful in the ungrouped list view.
 */
export const useReorderTasks = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reorderTasks>>, TError,{data: BodyType<ReorderTasksRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof reorderTasks>>,
        TError,
        {data: BodyType<ReorderTasksRequest>},
        TContext
      > => {
      return useMutation(getReorderTasksMutationOptions(options));
    }

export const getGetTaskCommentsUrl = (id: number,) => {




  return `/api/tasks/${id}/comments`
}

/**
 * @summary List a task's comments, oldest first
 */
export const getTaskComments = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<TaskComment[]> => {

  return customFetch<TaskComment[]>(getGetTaskCommentsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTaskCommentsQueryKey = (id: number,) => {
    return [
    `/api/tasks/${id}/comments`
    ] as const;
    }


export const getGetTaskCommentsQueryOptions = <TData = Awaited<ReturnType<typeof getTaskComments>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTaskComments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTaskCommentsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTaskComments>>> = ({ signal }) => getTaskComments(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTaskComments>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTaskCommentsQueryResult = NonNullable<Awaited<ReturnType<typeof getTaskComments>>>
export type GetTaskCommentsQueryError = ErrorType<unknown>


/**
 * @summary List a task's comments, oldest first
 */

export function useGetTaskComments<TData = Awaited<ReturnType<typeof getTaskComments>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTaskComments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTaskCommentsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateTaskCommentUrl = (id: number,) => {




  return `/api/tasks/${id}/comments`
}

/**
 * @summary Add a comment to a task
 */
export const createTaskComment = async (id: number,
    createTaskCommentRequest: CreateTaskCommentRequest, options?: Parameters<typeof customFetch>[1]): Promise<TaskComment> => {

  return customFetch<TaskComment>(getCreateTaskCommentUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createTaskCommentRequest)
  }
);}





export const getCreateTaskCommentMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTaskComment>>, TError,{id: number;data: BodyType<CreateTaskCommentRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTaskComment>>, TError,{id: number;data: BodyType<CreateTaskCommentRequest>}, TContext> => {

const mutationKey = ['createTaskComment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTaskComment>>, {id: number;data: BodyType<CreateTaskCommentRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  createTaskComment(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTaskCommentMutationResult = NonNullable<Awaited<ReturnType<typeof createTaskComment>>>
    export type CreateTaskCommentMutationBody = BodyType<CreateTaskCommentRequest>
    export type CreateTaskCommentMutationError = ErrorType<ApiError>

    /**
 * @summary Add a comment to a task
 */
export const useCreateTaskComment = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTaskComment>>, TError,{id: number;data: BodyType<CreateTaskCommentRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createTaskComment>>,
        TError,
        {id: number;data: BodyType<CreateTaskCommentRequest>},
        TContext
      > => {
      return useMutation(getCreateTaskCommentMutationOptions(options));
    }

export const getDeleteTaskCommentUrl = (id: number,) => {




  return `/api/task-comments/${id}`
}

/**
 * @summary Delete a comment
 */
export const deleteTaskComment = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDeleteTaskCommentUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteTaskCommentMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTaskComment>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTaskComment>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteTaskComment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTaskComment>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteTaskComment(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTaskCommentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTaskComment>>>

    export type DeleteTaskCommentMutationError = ErrorType<ApiError>

    /**
 * @summary Delete a comment
 */
export const useDeleteTaskComment = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTaskComment>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteTaskComment>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteTaskCommentMutationOptions(options));
    }

export const getGetTaskTimeBlocksUrl = () => {




  return `/api/task-time-blocks`
}

/**
 * @summary List every working period across every task — a task can have zero or more, one per work session
 */
export const getTaskTimeBlocks = async ( options?: Parameters<typeof customFetch>[1]): Promise<TaskTimeBlock[]> => {

  return customFetch<TaskTimeBlock[]>(getGetTaskTimeBlocksUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTaskTimeBlocksQueryKey = () => {
    return [
    `/api/task-time-blocks`
    ] as const;
    }


export const getGetTaskTimeBlocksQueryOptions = <TData = Awaited<ReturnType<typeof getTaskTimeBlocks>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTaskTimeBlocks>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTaskTimeBlocksQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTaskTimeBlocks>>> = ({ signal }) => getTaskTimeBlocks({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTaskTimeBlocks>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTaskTimeBlocksQueryResult = NonNullable<Awaited<ReturnType<typeof getTaskTimeBlocks>>>
export type GetTaskTimeBlocksQueryError = ErrorType<unknown>


/**
 * @summary List every working period across every task — a task can have zero or more, one per work session
 */

export function useGetTaskTimeBlocks<TData = Awaited<ReturnType<typeof getTaskTimeBlocks>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTaskTimeBlocks>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTaskTimeBlocksQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetCalendarEventsUrl = () => {




  return `/api/calendar-events`
}

/**
 * @summary List every calendar event (synced from Google, or created directly from Assistio)
 */
export const getCalendarEvents = async ( options?: Parameters<typeof customFetch>[1]): Promise<CalendarEvent[]> => {

  return customFetch<CalendarEvent[]>(getGetCalendarEventsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCalendarEventsQueryKey = () => {
    return [
    `/api/calendar-events`
    ] as const;
    }


export const getGetCalendarEventsQueryOptions = <TData = Awaited<ReturnType<typeof getCalendarEvents>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCalendarEvents>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCalendarEventsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCalendarEvents>>> = ({ signal }) => getCalendarEvents({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCalendarEvents>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCalendarEventsQueryResult = NonNullable<Awaited<ReturnType<typeof getCalendarEvents>>>
export type GetCalendarEventsQueryError = ErrorType<unknown>


/**
 * @summary List every calendar event (synced from Google, or created directly from Assistio)
 */

export function useGetCalendarEvents<TData = Awaited<ReturnType<typeof getCalendarEvents>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCalendarEvents>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCalendarEventsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateCalendarEventUrl = () => {




  return `/api/calendar-events`
}

/**
 * @summary Create and send a new meeting via Google Calendar or Outlook Calendar
 */
export const createCalendarEvent = async (createMeetingRequest: CreateMeetingRequest, options?: Parameters<typeof customFetch>[1]): Promise<CalendarEvent> => {

  return customFetch<CalendarEvent>(getCreateCalendarEventUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createMeetingRequest)
  }
);}





export const getCreateCalendarEventMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCalendarEvent>>, TError,{data: BodyType<CreateMeetingRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCalendarEvent>>, TError,{data: BodyType<CreateMeetingRequest>}, TContext> => {

const mutationKey = ['createCalendarEvent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCalendarEvent>>, {data: BodyType<CreateMeetingRequest>}> = (props) => {
          const {data} = props ?? {};

          return  createCalendarEvent(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCalendarEventMutationResult = NonNullable<Awaited<ReturnType<typeof createCalendarEvent>>>
    export type CreateCalendarEventMutationBody = BodyType<CreateMeetingRequest>
    export type CreateCalendarEventMutationError = ErrorType<ApiError>

    /**
 * @summary Create and send a new meeting via Google Calendar or Outlook Calendar
 */
export const useCreateCalendarEvent = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCalendarEvent>>, TError,{data: BodyType<CreateMeetingRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createCalendarEvent>>,
        TError,
        {data: BodyType<CreateMeetingRequest>},
        TContext
      > => {
      return useMutation(getCreateCalendarEventMutationOptions(options));
    }

export const getCreateTaskTimeBlockUrl = (id: number,) => {




  return `/api/tasks/${id}/time-blocks`
}

/**
 * @summary Add a working period to a task
 */
export const createTaskTimeBlock = async (id: number,
    createTaskTimeBlockRequest: CreateTaskTimeBlockRequest, options?: Parameters<typeof customFetch>[1]): Promise<TaskTimeBlock> => {

  return customFetch<TaskTimeBlock>(getCreateTaskTimeBlockUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createTaskTimeBlockRequest)
  }
);}





export const getCreateTaskTimeBlockMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTaskTimeBlock>>, TError,{id: number;data: BodyType<CreateTaskTimeBlockRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTaskTimeBlock>>, TError,{id: number;data: BodyType<CreateTaskTimeBlockRequest>}, TContext> => {

const mutationKey = ['createTaskTimeBlock'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTaskTimeBlock>>, {id: number;data: BodyType<CreateTaskTimeBlockRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  createTaskTimeBlock(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTaskTimeBlockMutationResult = NonNullable<Awaited<ReturnType<typeof createTaskTimeBlock>>>
    export type CreateTaskTimeBlockMutationBody = BodyType<CreateTaskTimeBlockRequest>
    export type CreateTaskTimeBlockMutationError = ErrorType<ApiError>

    /**
 * @summary Add a working period to a task
 */
export const useCreateTaskTimeBlock = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTaskTimeBlock>>, TError,{id: number;data: BodyType<CreateTaskTimeBlockRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createTaskTimeBlock>>,
        TError,
        {id: number;data: BodyType<CreateTaskTimeBlockRequest>},
        TContext
      > => {
      return useMutation(getCreateTaskTimeBlockMutationOptions(options));
    }

export const getUpdateTaskTimeBlockUrl = (id: number,) => {




  return `/api/time-blocks/${id}`
}

/**
 * @summary Reschedule or resize a working period
 */
export const updateTaskTimeBlock = async (id: number,
    updateTaskTimeBlockRequest: UpdateTaskTimeBlockRequest, options?: Parameters<typeof customFetch>[1]): Promise<TaskTimeBlock> => {

  return customFetch<TaskTimeBlock>(getUpdateTaskTimeBlockUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateTaskTimeBlockRequest)
  }
);}





export const getUpdateTaskTimeBlockMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTaskTimeBlock>>, TError,{id: number;data: BodyType<UpdateTaskTimeBlockRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTaskTimeBlock>>, TError,{id: number;data: BodyType<UpdateTaskTimeBlockRequest>}, TContext> => {

const mutationKey = ['updateTaskTimeBlock'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTaskTimeBlock>>, {id: number;data: BodyType<UpdateTaskTimeBlockRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateTaskTimeBlock(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTaskTimeBlockMutationResult = NonNullable<Awaited<ReturnType<typeof updateTaskTimeBlock>>>
    export type UpdateTaskTimeBlockMutationBody = BodyType<UpdateTaskTimeBlockRequest>
    export type UpdateTaskTimeBlockMutationError = ErrorType<ApiError>

    /**
 * @summary Reschedule or resize a working period
 */
export const useUpdateTaskTimeBlock = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTaskTimeBlock>>, TError,{id: number;data: BodyType<UpdateTaskTimeBlockRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateTaskTimeBlock>>,
        TError,
        {id: number;data: BodyType<UpdateTaskTimeBlockRequest>},
        TContext
      > => {
      return useMutation(getUpdateTaskTimeBlockMutationOptions(options));
    }

export const getDeleteTaskTimeBlockUrl = (id: number,) => {




  return `/api/time-blocks/${id}`
}

/**
 * @summary Remove a working period
 */
export const deleteTaskTimeBlock = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDeleteTaskTimeBlockUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteTaskTimeBlockMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTaskTimeBlock>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTaskTimeBlock>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteTaskTimeBlock'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTaskTimeBlock>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteTaskTimeBlock(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTaskTimeBlockMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTaskTimeBlock>>>

    export type DeleteTaskTimeBlockMutationError = ErrorType<ApiError>

    /**
 * @summary Remove a working period
 */
export const useDeleteTaskTimeBlock = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTaskTimeBlock>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteTaskTimeBlock>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteTaskTimeBlockMutationOptions(options));
    }

export const getGetWellbeingSettingsUrl = () => {




  return `/api/wellbeing-settings`
}

/**
 * @summary Get the wellbeing settings (morning check-in, shutdown ritual, break reminders, Pomodoro, working-hours nudges) — creates a default row on first call
 */
export const getWellbeingSettings = async ( options?: Parameters<typeof customFetch>[1]): Promise<WellbeingSettings> => {

  return customFetch<WellbeingSettings>(getGetWellbeingSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetWellbeingSettingsQueryKey = () => {
    return [
    `/api/wellbeing-settings`
    ] as const;
    }


export const getGetWellbeingSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getWellbeingSettings>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWellbeingSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWellbeingSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWellbeingSettings>>> = ({ signal }) => getWellbeingSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWellbeingSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetWellbeingSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getWellbeingSettings>>>
export type GetWellbeingSettingsQueryError = ErrorType<unknown>


/**
 * @summary Get the wellbeing settings (morning check-in, shutdown ritual, break reminders, Pomodoro, working-hours nudges) — creates a default row on first call
 */

export function useGetWellbeingSettings<TData = Awaited<ReturnType<typeof getWellbeingSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWellbeingSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetWellbeingSettingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateWellbeingSettingsUrl = () => {




  return `/api/wellbeing-settings`
}

/**
 * @summary Update one or more wellbeing settings
 */
export const updateWellbeingSettings = async (updateWellbeingSettingsRequest: UpdateWellbeingSettingsRequest, options?: Parameters<typeof customFetch>[1]): Promise<WellbeingSettings> => {

  return customFetch<WellbeingSettings>(getUpdateWellbeingSettingsUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateWellbeingSettingsRequest)
  }
);}





export const getUpdateWellbeingSettingsMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWellbeingSettings>>, TError,{data: BodyType<UpdateWellbeingSettingsRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateWellbeingSettings>>, TError,{data: BodyType<UpdateWellbeingSettingsRequest>}, TContext> => {

const mutationKey = ['updateWellbeingSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateWellbeingSettings>>, {data: BodyType<UpdateWellbeingSettingsRequest>}> = (props) => {
          const {data} = props ?? {};

          return  updateWellbeingSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateWellbeingSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateWellbeingSettings>>>
    export type UpdateWellbeingSettingsMutationBody = BodyType<UpdateWellbeingSettingsRequest>
    export type UpdateWellbeingSettingsMutationError = ErrorType<ApiError>

    /**
 * @summary Update one or more wellbeing settings
 */
export const useUpdateWellbeingSettings = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWellbeingSettings>>, TError,{data: BodyType<UpdateWellbeingSettingsRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateWellbeingSettings>>,
        TError,
        {data: BodyType<UpdateWellbeingSettingsRequest>},
        TContext
      > => {
      return useMutation(getUpdateWellbeingSettingsMutationOptions(options));
    }

export const getGetAppSettingsUrl = () => {




  return `/api/app-settings`
}

/**
 * @summary Get general app-level feature settings (distinct from wellbeing settings) — creates a default row on first call
 */
export const getAppSettings = async ( options?: Parameters<typeof customFetch>[1]): Promise<AppSettings> => {

  return customFetch<AppSettings>(getGetAppSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAppSettingsQueryKey = () => {
    return [
    `/api/app-settings`
    ] as const;
    }


export const getGetAppSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getAppSettings>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAppSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAppSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAppSettings>>> = ({ signal }) => getAppSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAppSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAppSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getAppSettings>>>
export type GetAppSettingsQueryError = ErrorType<unknown>


/**
 * @summary Get general app-level feature settings (distinct from wellbeing settings) — creates a default row on first call
 */

export function useGetAppSettings<TData = Awaited<ReturnType<typeof getAppSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAppSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAppSettingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateAppSettingsUrl = () => {




  return `/api/app-settings`
}

/**
 * @summary Update one or more app-level settings
 */
export const updateAppSettings = async (updateAppSettingsRequest: UpdateAppSettingsRequest, options?: Parameters<typeof customFetch>[1]): Promise<AppSettings> => {

  return customFetch<AppSettings>(getUpdateAppSettingsUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateAppSettingsRequest)
  }
);}





export const getUpdateAppSettingsMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAppSettings>>, TError,{data: BodyType<UpdateAppSettingsRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAppSettings>>, TError,{data: BodyType<UpdateAppSettingsRequest>}, TContext> => {

const mutationKey = ['updateAppSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAppSettings>>, {data: BodyType<UpdateAppSettingsRequest>}> = (props) => {
          const {data} = props ?? {};

          return  updateAppSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAppSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateAppSettings>>>
    export type UpdateAppSettingsMutationBody = BodyType<UpdateAppSettingsRequest>
    export type UpdateAppSettingsMutationError = ErrorType<ApiError>

    /**
 * @summary Update one or more app-level settings
 */
export const useUpdateAppSettings = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAppSettings>>, TError,{data: BodyType<UpdateAppSettingsRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateAppSettings>>,
        TError,
        {data: BodyType<UpdateAppSettingsRequest>},
        TContext
      > => {
      return useMutation(getUpdateAppSettingsMutationOptions(options));
    }

export const getGetTrustedImageSendersUrl = () => {




  return `/api/trusted-image-senders`
}

/**
 * @summary List sender email addresses trusted to auto-load remote images. Remote images in a message body are blocked by default (they can act as read-receipt/tracking pixels) until shown per-message client-side or the sender is trusted here — provider-agnostic, applies to every message source uniformly.

 */
export const getTrustedImageSenders = async ( options?: Parameters<typeof customFetch>[1]): Promise<string[]> => {

  return customFetch<string[]>(getGetTrustedImageSendersUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTrustedImageSendersQueryKey = () => {
    return [
    `/api/trusted-image-senders`
    ] as const;
    }


export const getGetTrustedImageSendersQueryOptions = <TData = Awaited<ReturnType<typeof getTrustedImageSenders>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTrustedImageSenders>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTrustedImageSendersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTrustedImageSenders>>> = ({ signal }) => getTrustedImageSenders({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTrustedImageSenders>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTrustedImageSendersQueryResult = NonNullable<Awaited<ReturnType<typeof getTrustedImageSenders>>>
export type GetTrustedImageSendersQueryError = ErrorType<unknown>


/**
 * @summary List sender email addresses trusted to auto-load remote images. Remote images in a message body are blocked by default (they can act as read-receipt/tracking pixels) until shown per-message client-side or the sender is trusted here — provider-agnostic, applies to every message source uniformly.

 */

export function useGetTrustedImageSenders<TData = Awaited<ReturnType<typeof getTrustedImageSenders>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTrustedImageSenders>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTrustedImageSendersQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAddTrustedImageSenderUrl = () => {




  return `/api/trusted-image-senders`
}

/**
 * @summary Trust a sender — their messages auto-load remote images from now on
 */
export const addTrustedImageSender = async (addTrustedImageSenderRequest: AddTrustedImageSenderRequest, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getAddTrustedImageSenderUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(addTrustedImageSenderRequest)
  }
);}





export const getAddTrustedImageSenderMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addTrustedImageSender>>, TError,{data: BodyType<AddTrustedImageSenderRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addTrustedImageSender>>, TError,{data: BodyType<AddTrustedImageSenderRequest>}, TContext> => {

const mutationKey = ['addTrustedImageSender'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addTrustedImageSender>>, {data: BodyType<AddTrustedImageSenderRequest>}> = (props) => {
          const {data} = props ?? {};

          return  addTrustedImageSender(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddTrustedImageSenderMutationResult = NonNullable<Awaited<ReturnType<typeof addTrustedImageSender>>>
    export type AddTrustedImageSenderMutationBody = BodyType<AddTrustedImageSenderRequest>
    export type AddTrustedImageSenderMutationError = ErrorType<ApiError>

    /**
 * @summary Trust a sender — their messages auto-load remote images from now on
 */
export const useAddTrustedImageSender = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addTrustedImageSender>>, TError,{data: BodyType<AddTrustedImageSenderRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof addTrustedImageSender>>,
        TError,
        {data: BodyType<AddTrustedImageSenderRequest>},
        TContext
      > => {
      return useMutation(getAddTrustedImageSenderMutationOptions(options));
    }

export const getRemoveTrustedImageSenderUrl = (email: string,) => {




  return `/api/trusted-image-senders/${email}`
}

/**
 * @summary Un-trust a sender — remote images go back to blocked-by-default for them
 */
export const removeTrustedImageSender = async (email: string, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getRemoveTrustedImageSenderUrl(email),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getRemoveTrustedImageSenderMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeTrustedImageSender>>, TError,{email: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof removeTrustedImageSender>>, TError,{email: string}, TContext> => {

const mutationKey = ['removeTrustedImageSender'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeTrustedImageSender>>, {email: string}> = (props) => {
          const {email} = props ?? {};

          return  removeTrustedImageSender(email,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveTrustedImageSenderMutationResult = NonNullable<Awaited<ReturnType<typeof removeTrustedImageSender>>>

    export type RemoveTrustedImageSenderMutationError = ErrorType<unknown>

    /**
 * @summary Un-trust a sender — remote images go back to blocked-by-default for them
 */
export const useRemoveTrustedImageSender = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeTrustedImageSender>>, TError,{email: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof removeTrustedImageSender>>,
        TError,
        {email: string},
        TContext
      > => {
      return useMutation(getRemoveTrustedImageSenderMutationOptions(options));
    }

export const getGetTaskTagsUrl = () => {




  return `/api/task-tags`
}

/**
 * @summary List every priority tag across every list. Priority levels are per-list, not a single shared scheme — filter client-side by listId for a specific list's own set. New lists are seeded with a default set of 4 when created (see POST /lists).

 */
export const getTaskTags = async ( options?: Parameters<typeof customFetch>[1]): Promise<TaskTag[]> => {

  return customFetch<TaskTag[]>(getGetTaskTagsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTaskTagsQueryKey = () => {
    return [
    `/api/task-tags`
    ] as const;
    }


export const getGetTaskTagsQueryOptions = <TData = Awaited<ReturnType<typeof getTaskTags>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTaskTags>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTaskTagsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTaskTags>>> = ({ signal }) => getTaskTags({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTaskTags>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTaskTagsQueryResult = NonNullable<Awaited<ReturnType<typeof getTaskTags>>>
export type GetTaskTagsQueryError = ErrorType<unknown>


/**
 * @summary List every priority tag across every list. Priority levels are per-list, not a single shared scheme — filter client-side by listId for a specific list's own set. New lists are seeded with a default set of 4 when created (see POST /lists).

 */

export function useGetTaskTags<TData = Awaited<ReturnType<typeof getTaskTags>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTaskTags>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTaskTagsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateTaskTagUrl = () => {




  return `/api/task-tags`
}

/**
 * @summary Create a new priority tag
 */
export const createTaskTag = async (createTaskTagRequest: CreateTaskTagRequest, options?: Parameters<typeof customFetch>[1]): Promise<TaskTag> => {

  return customFetch<TaskTag>(getCreateTaskTagUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createTaskTagRequest)
  }
);}





export const getCreateTaskTagMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTaskTag>>, TError,{data: BodyType<CreateTaskTagRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTaskTag>>, TError,{data: BodyType<CreateTaskTagRequest>}, TContext> => {

const mutationKey = ['createTaskTag'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTaskTag>>, {data: BodyType<CreateTaskTagRequest>}> = (props) => {
          const {data} = props ?? {};

          return  createTaskTag(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTaskTagMutationResult = NonNullable<Awaited<ReturnType<typeof createTaskTag>>>
    export type CreateTaskTagMutationBody = BodyType<CreateTaskTagRequest>
    export type CreateTaskTagMutationError = ErrorType<ApiError>

    /**
 * @summary Create a new priority tag
 */
export const useCreateTaskTag = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTaskTag>>, TError,{data: BodyType<CreateTaskTagRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createTaskTag>>,
        TError,
        {data: BodyType<CreateTaskTagRequest>},
        TContext
      > => {
      return useMutation(getCreateTaskTagMutationOptions(options));
    }

export const getUpdateTaskTagUrl = (id: number,) => {




  return `/api/task-tags/${id}`
}

/**
 * @summary Rename or recolor a priority tag
 */
export const updateTaskTag = async (id: number,
    updateTaskTagRequest: UpdateTaskTagRequest, options?: Parameters<typeof customFetch>[1]): Promise<TaskTag> => {

  return customFetch<TaskTag>(getUpdateTaskTagUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateTaskTagRequest)
  }
);}





export const getUpdateTaskTagMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTaskTag>>, TError,{id: number;data: BodyType<UpdateTaskTagRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTaskTag>>, TError,{id: number;data: BodyType<UpdateTaskTagRequest>}, TContext> => {

const mutationKey = ['updateTaskTag'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTaskTag>>, {id: number;data: BodyType<UpdateTaskTagRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateTaskTag(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTaskTagMutationResult = NonNullable<Awaited<ReturnType<typeof updateTaskTag>>>
    export type UpdateTaskTagMutationBody = BodyType<UpdateTaskTagRequest>
    export type UpdateTaskTagMutationError = ErrorType<ApiError>

    /**
 * @summary Rename or recolor a priority tag
 */
export const useUpdateTaskTag = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTaskTag>>, TError,{id: number;data: BodyType<UpdateTaskTagRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateTaskTag>>,
        TError,
        {id: number;data: BodyType<UpdateTaskTagRequest>},
        TContext
      > => {
      return useMutation(getUpdateTaskTagMutationOptions(options));
    }

export const getDeleteTaskTagUrl = (id: number,) => {




  return `/api/task-tags/${id}`
}

/**
 * @summary Delete a priority tag — tasks referencing it fall back to no priority, they are not deleted
 */
export const deleteTaskTag = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDeleteTaskTagUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteTaskTagMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTaskTag>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTaskTag>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteTaskTag'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTaskTag>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteTaskTag(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTaskTagMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTaskTag>>>

    export type DeleteTaskTagMutationError = ErrorType<unknown>

    /**
 * @summary Delete a priority tag — tasks referencing it fall back to no priority, they are not deleted
 */
export const useDeleteTaskTag = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTaskTag>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteTaskTag>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteTaskTagMutationOptions(options));
    }

export const getGetTaskStatusesUrl = () => {




  return `/api/task-statuses`
}

/**
 * @summary List every custom status across every list, on top of the 4 fixed built-in statuses (todo/in_progress/blocked/done). Custom statuses only apply to native tasks — a Jira/ADO-synced task's status is a normalized mirror of its external workflow (see Task.rawStatus) and can't be set to a custom one. Statuses are per-list, same convention as priority tags (GET /task-tags).

 */
export const getTaskStatuses = async ( options?: Parameters<typeof customFetch>[1]): Promise<TaskStatus[]> => {

  return customFetch<TaskStatus[]>(getGetTaskStatusesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTaskStatusesQueryKey = () => {
    return [
    `/api/task-statuses`
    ] as const;
    }


export const getGetTaskStatusesQueryOptions = <TData = Awaited<ReturnType<typeof getTaskStatuses>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTaskStatuses>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTaskStatusesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTaskStatuses>>> = ({ signal }) => getTaskStatuses({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTaskStatuses>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTaskStatusesQueryResult = NonNullable<Awaited<ReturnType<typeof getTaskStatuses>>>
export type GetTaskStatusesQueryError = ErrorType<unknown>


/**
 * @summary List every custom status across every list, on top of the 4 fixed built-in statuses (todo/in_progress/blocked/done). Custom statuses only apply to native tasks — a Jira/ADO-synced task's status is a normalized mirror of its external workflow (see Task.rawStatus) and can't be set to a custom one. Statuses are per-list, same convention as priority tags (GET /task-tags).

 */

export function useGetTaskStatuses<TData = Awaited<ReturnType<typeof getTaskStatuses>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTaskStatuses>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTaskStatusesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateTaskStatusUrl = () => {




  return `/api/task-statuses`
}

/**
 * @summary Create a new custom status
 */
export const createTaskStatus = async (createTaskStatusRequest: CreateTaskStatusRequest, options?: Parameters<typeof customFetch>[1]): Promise<TaskStatus> => {

  return customFetch<TaskStatus>(getCreateTaskStatusUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createTaskStatusRequest)
  }
);}





export const getCreateTaskStatusMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTaskStatus>>, TError,{data: BodyType<CreateTaskStatusRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTaskStatus>>, TError,{data: BodyType<CreateTaskStatusRequest>}, TContext> => {

const mutationKey = ['createTaskStatus'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTaskStatus>>, {data: BodyType<CreateTaskStatusRequest>}> = (props) => {
          const {data} = props ?? {};

          return  createTaskStatus(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTaskStatusMutationResult = NonNullable<Awaited<ReturnType<typeof createTaskStatus>>>
    export type CreateTaskStatusMutationBody = BodyType<CreateTaskStatusRequest>
    export type CreateTaskStatusMutationError = ErrorType<ApiError>

    /**
 * @summary Create a new custom status
 */
export const useCreateTaskStatus = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTaskStatus>>, TError,{data: BodyType<CreateTaskStatusRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createTaskStatus>>,
        TError,
        {data: BodyType<CreateTaskStatusRequest>},
        TContext
      > => {
      return useMutation(getCreateTaskStatusMutationOptions(options));
    }

export const getUpdateTaskStatusUrl = (id: number,) => {




  return `/api/task-statuses/${id}`
}

/**
 * @summary Rename or recolor a custom status
 */
export const updateTaskStatus = async (id: number,
    updateTaskStatusRequest: UpdateTaskStatusRequest, options?: Parameters<typeof customFetch>[1]): Promise<TaskStatus> => {

  return customFetch<TaskStatus>(getUpdateTaskStatusUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateTaskStatusRequest)
  }
);}





export const getUpdateTaskStatusMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTaskStatus>>, TError,{id: number;data: BodyType<UpdateTaskStatusRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTaskStatus>>, TError,{id: number;data: BodyType<UpdateTaskStatusRequest>}, TContext> => {

const mutationKey = ['updateTaskStatus'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTaskStatus>>, {id: number;data: BodyType<UpdateTaskStatusRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateTaskStatus(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTaskStatusMutationResult = NonNullable<Awaited<ReturnType<typeof updateTaskStatus>>>
    export type UpdateTaskStatusMutationBody = BodyType<UpdateTaskStatusRequest>
    export type UpdateTaskStatusMutationError = ErrorType<ApiError>

    /**
 * @summary Rename or recolor a custom status
 */
export const useUpdateTaskStatus = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTaskStatus>>, TError,{id: number;data: BodyType<UpdateTaskStatusRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateTaskStatus>>,
        TError,
        {id: number;data: BodyType<UpdateTaskStatusRequest>},
        TContext
      > => {
      return useMutation(getUpdateTaskStatusMutationOptions(options));
    }

export const getDeleteTaskStatusUrl = (id: number,) => {




  return `/api/task-statuses/${id}`
}

/**
 * @summary Delete a custom status — tasks using it fall back to "To Do", they are not deleted
 */
export const deleteTaskStatus = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDeleteTaskStatusUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteTaskStatusMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTaskStatus>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTaskStatus>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteTaskStatus'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTaskStatus>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteTaskStatus(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTaskStatusMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTaskStatus>>>

    export type DeleteTaskStatusMutationError = ErrorType<ApiError>

    /**
 * @summary Delete a custom status — tasks using it fall back to "To Do", they are not deleted
 */
export const useDeleteTaskStatus = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTaskStatus>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteTaskStatus>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteTaskStatusMutationOptions(options));
    }

export const getGetTaskViewsUrl = () => {




  return `/api/task-views`
}

/**
 * @summary List every saved filter/sort/group view across every list, plus the "All Tasks" master scope (listId null). The frontend filters this list down to whichever scope is currently open.

 */
export const getTaskViews = async ( options?: Parameters<typeof customFetch>[1]): Promise<TaskView[]> => {

  return customFetch<TaskView[]>(getGetTaskViewsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTaskViewsQueryKey = () => {
    return [
    `/api/task-views`
    ] as const;
    }


export const getGetTaskViewsQueryOptions = <TData = Awaited<ReturnType<typeof getTaskViews>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTaskViews>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTaskViewsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTaskViews>>> = ({ signal }) => getTaskViews({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTaskViews>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTaskViewsQueryResult = NonNullable<Awaited<ReturnType<typeof getTaskViews>>>
export type GetTaskViewsQueryError = ErrorType<unknown>


/**
 * @summary List every saved filter/sort/group view across every list, plus the "All Tasks" master scope (listId null). The frontend filters this list down to whichever scope is currently open.

 */

export function useGetTaskViews<TData = Awaited<ReturnType<typeof getTaskViews>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTaskViews>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTaskViewsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateTaskViewUrl = () => {




  return `/api/task-views`
}

/**
 * @summary Save the current filter/sort/group state as a new named view
 */
export const createTaskView = async (createTaskViewRequest: CreateTaskViewRequest, options?: Parameters<typeof customFetch>[1]): Promise<TaskView> => {

  return customFetch<TaskView>(getCreateTaskViewUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createTaskViewRequest)
  }
);}





export const getCreateTaskViewMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTaskView>>, TError,{data: BodyType<CreateTaskViewRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTaskView>>, TError,{data: BodyType<CreateTaskViewRequest>}, TContext> => {

const mutationKey = ['createTaskView'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTaskView>>, {data: BodyType<CreateTaskViewRequest>}> = (props) => {
          const {data} = props ?? {};

          return  createTaskView(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTaskViewMutationResult = NonNullable<Awaited<ReturnType<typeof createTaskView>>>
    export type CreateTaskViewMutationBody = BodyType<CreateTaskViewRequest>
    export type CreateTaskViewMutationError = ErrorType<ApiError>

    /**
 * @summary Save the current filter/sort/group state as a new named view
 */
export const useCreateTaskView = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTaskView>>, TError,{data: BodyType<CreateTaskViewRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createTaskView>>,
        TError,
        {data: BodyType<CreateTaskViewRequest>},
        TContext
      > => {
      return useMutation(getCreateTaskViewMutationOptions(options));
    }

export const getUpdateTaskViewUrl = (id: number,) => {




  return `/api/task-views/${id}`
}

/**
 * @summary Rename a view, replace its saved filters, or mark it default — setting isDefault true unsets any other default view in the same scope (same listId, including both null) for this user.

 */
export const updateTaskView = async (id: number,
    updateTaskViewRequest: UpdateTaskViewRequest, options?: Parameters<typeof customFetch>[1]): Promise<TaskView> => {

  return customFetch<TaskView>(getUpdateTaskViewUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateTaskViewRequest)
  }
);}





export const getUpdateTaskViewMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTaskView>>, TError,{id: number;data: BodyType<UpdateTaskViewRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTaskView>>, TError,{id: number;data: BodyType<UpdateTaskViewRequest>}, TContext> => {

const mutationKey = ['updateTaskView'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTaskView>>, {id: number;data: BodyType<UpdateTaskViewRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateTaskView(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTaskViewMutationResult = NonNullable<Awaited<ReturnType<typeof updateTaskView>>>
    export type UpdateTaskViewMutationBody = BodyType<UpdateTaskViewRequest>
    export type UpdateTaskViewMutationError = ErrorType<ApiError>

    /**
 * @summary Rename a view, replace its saved filters, or mark it default — setting isDefault true unsets any other default view in the same scope (same listId, including both null) for this user.

 */
export const useUpdateTaskView = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTaskView>>, TError,{id: number;data: BodyType<UpdateTaskViewRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateTaskView>>,
        TError,
        {id: number;data: BodyType<UpdateTaskViewRequest>},
        TContext
      > => {
      return useMutation(getUpdateTaskViewMutationOptions(options));
    }

export const getDeleteTaskViewUrl = (id: number,) => {




  return `/api/task-views/${id}`
}

/**
 * @summary Delete a saved view
 */
export const deleteTaskView = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDeleteTaskViewUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteTaskViewMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTaskView>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTaskView>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteTaskView'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTaskView>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteTaskView(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTaskViewMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTaskView>>>

    export type DeleteTaskViewMutationError = ErrorType<ApiError>

    /**
 * @summary Delete a saved view
 */
export const useDeleteTaskView = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTaskView>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteTaskView>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteTaskViewMutationOptions(options));
    }

export const getGetPinnedViewsUrl = () => {




  return `/api/pinned-views`
}

/**
 * @summary List this user's pinned view tabs, ordered left-to-right for the bar along the bottom of the app. Empty when nothing is pinned — the bar is absent entirely in that case (finding #6).

 */
export const getPinnedViews = async ( options?: Parameters<typeof customFetch>[1]): Promise<PinnedView[]> => {

  return customFetch<PinnedView[]>(getGetPinnedViewsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPinnedViewsQueryKey = () => {
    return [
    `/api/pinned-views`
    ] as const;
    }


export const getGetPinnedViewsQueryOptions = <TData = Awaited<ReturnType<typeof getPinnedViews>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPinnedViews>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPinnedViewsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPinnedViews>>> = ({ signal }) => getPinnedViews({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPinnedViews>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPinnedViewsQueryResult = NonNullable<Awaited<ReturnType<typeof getPinnedViews>>>
export type GetPinnedViewsQueryError = ErrorType<unknown>


/**
 * @summary List this user's pinned view tabs, ordered left-to-right for the bar along the bottom of the app. Empty when nothing is pinned — the bar is absent entirely in that case (finding #6).

 */

export function useGetPinnedViews<TData = Awaited<ReturnType<typeof getPinnedViews>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPinnedViews>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPinnedViewsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreatePinnedViewUrl = () => {




  return `/api/pinned-views`
}

/**
 * @summary Pin the given path. Idempotent per (user, path): pinning an already pinned location returns the existing pin with 200 rather than creating a duplicate, so the pin control can toggle safely.

 */
export const createPinnedView = async (createPinnedViewRequest: CreatePinnedViewRequest, options?: Parameters<typeof customFetch>[1]): Promise<PinnedView> => {

  return customFetch<PinnedView>(getCreatePinnedViewUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createPinnedViewRequest)
  }
);}





export const getCreatePinnedViewMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPinnedView>>, TError,{data: BodyType<CreatePinnedViewRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPinnedView>>, TError,{data: BodyType<CreatePinnedViewRequest>}, TContext> => {

const mutationKey = ['createPinnedView'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPinnedView>>, {data: BodyType<CreatePinnedViewRequest>}> = (props) => {
          const {data} = props ?? {};

          return  createPinnedView(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePinnedViewMutationResult = NonNullable<Awaited<ReturnType<typeof createPinnedView>>>
    export type CreatePinnedViewMutationBody = BodyType<CreatePinnedViewRequest>
    export type CreatePinnedViewMutationError = ErrorType<ApiError>

    /**
 * @summary Pin the given path. Idempotent per (user, path): pinning an already pinned location returns the existing pin with 200 rather than creating a duplicate, so the pin control can toggle safely.

 */
export const useCreatePinnedView = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPinnedView>>, TError,{data: BodyType<CreatePinnedViewRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createPinnedView>>,
        TError,
        {data: BodyType<CreatePinnedViewRequest>},
        TContext
      > => {
      return useMutation(getCreatePinnedViewMutationOptions(options));
    }

export const getReorderPinnedViewsUrl = () => {




  return `/api/pinned-views/order`
}

/**
 * @summary Replace the whole ordering. The body lists every pinned view id in the desired left-to-right order; sortOrder is rewritten to the array index. Ids not belonging to this user are ignored.

 */
export const reorderPinnedViews = async (reorderPinnedViewsRequest: ReorderPinnedViewsRequest, options?: Parameters<typeof customFetch>[1]): Promise<PinnedView[]> => {

  return customFetch<PinnedView[]>(getReorderPinnedViewsUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(reorderPinnedViewsRequest)
  }
);}





export const getReorderPinnedViewsMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reorderPinnedViews>>, TError,{data: BodyType<ReorderPinnedViewsRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reorderPinnedViews>>, TError,{data: BodyType<ReorderPinnedViewsRequest>}, TContext> => {

const mutationKey = ['reorderPinnedViews'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reorderPinnedViews>>, {data: BodyType<ReorderPinnedViewsRequest>}> = (props) => {
          const {data} = props ?? {};

          return  reorderPinnedViews(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReorderPinnedViewsMutationResult = NonNullable<Awaited<ReturnType<typeof reorderPinnedViews>>>
    export type ReorderPinnedViewsMutationBody = BodyType<ReorderPinnedViewsRequest>
    export type ReorderPinnedViewsMutationError = ErrorType<ApiError>

    /**
 * @summary Replace the whole ordering. The body lists every pinned view id in the desired left-to-right order; sortOrder is rewritten to the array index. Ids not belonging to this user are ignored.

 */
export const useReorderPinnedViews = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reorderPinnedViews>>, TError,{data: BodyType<ReorderPinnedViewsRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof reorderPinnedViews>>,
        TError,
        {data: BodyType<ReorderPinnedViewsRequest>},
        TContext
      > => {
      return useMutation(getReorderPinnedViewsMutationOptions(options));
    }

export const getUpdatePinnedViewUrl = (id: number,) => {




  return `/api/pinned-views/${id}`
}

/**
 * @summary Rename a pinned view tab. A renamed tab keeps its name for good; an auto-named one re-derives its label from the route, so renaming the underlying folder or list renames the tab too. Sending a null label returns the tab to auto-naming.

 */
export const updatePinnedView = async (id: number,
    updatePinnedViewRequest: UpdatePinnedViewRequest, options?: Parameters<typeof customFetch>[1]): Promise<PinnedView> => {

  return customFetch<PinnedView>(getUpdatePinnedViewUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updatePinnedViewRequest)
  }
);}





export const getUpdatePinnedViewMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePinnedView>>, TError,{id: number;data: BodyType<UpdatePinnedViewRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePinnedView>>, TError,{id: number;data: BodyType<UpdatePinnedViewRequest>}, TContext> => {

const mutationKey = ['updatePinnedView'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePinnedView>>, {id: number;data: BodyType<UpdatePinnedViewRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  updatePinnedView(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePinnedViewMutationResult = NonNullable<Awaited<ReturnType<typeof updatePinnedView>>>
    export type UpdatePinnedViewMutationBody = BodyType<UpdatePinnedViewRequest>
    export type UpdatePinnedViewMutationError = ErrorType<ApiError>

    /**
 * @summary Rename a pinned view tab. A renamed tab keeps its name for good; an auto-named one re-derives its label from the route, so renaming the underlying folder or list renames the tab too. Sending a null label returns the tab to auto-naming.

 */
export const useUpdatePinnedView = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePinnedView>>, TError,{id: number;data: BodyType<UpdatePinnedViewRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePinnedView>>,
        TError,
        {id: number;data: BodyType<UpdatePinnedViewRequest>},
        TContext
      > => {
      return useMutation(getUpdatePinnedViewMutationOptions(options));
    }

export const getDeletePinnedViewUrl = (id: number,) => {




  return `/api/pinned-views/${id}`
}

/**
 * @summary Unpin (remove a tab).
 */
export const deletePinnedView = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDeletePinnedViewUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeletePinnedViewMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePinnedView>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePinnedView>>, TError,{id: number}, TContext> => {

const mutationKey = ['deletePinnedView'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePinnedView>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deletePinnedView(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePinnedViewMutationResult = NonNullable<Awaited<ReturnType<typeof deletePinnedView>>>

    export type DeletePinnedViewMutationError = ErrorType<ApiError>

    /**
 * @summary Unpin (remove a tab).
 */
export const useDeletePinnedView = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePinnedView>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deletePinnedView>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeletePinnedViewMutationOptions(options));
    }

export const getGetTaskFieldsUrl = () => {




  return `/api/task-fields`
}

/**
 * @summary List every custom field definition across every list — per-list scoping, same convention as priority tags and statuses
 */
export const getTaskFields = async ( options?: Parameters<typeof customFetch>[1]): Promise<TaskField[]> => {

  return customFetch<TaskField[]>(getGetTaskFieldsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTaskFieldsQueryKey = () => {
    return [
    `/api/task-fields`
    ] as const;
    }


export const getGetTaskFieldsQueryOptions = <TData = Awaited<ReturnType<typeof getTaskFields>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTaskFields>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTaskFieldsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTaskFields>>> = ({ signal }) => getTaskFields({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTaskFields>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTaskFieldsQueryResult = NonNullable<Awaited<ReturnType<typeof getTaskFields>>>
export type GetTaskFieldsQueryError = ErrorType<unknown>


/**
 * @summary List every custom field definition across every list — per-list scoping, same convention as priority tags and statuses
 */

export function useGetTaskFields<TData = Awaited<ReturnType<typeof getTaskFields>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTaskFields>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTaskFieldsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateTaskFieldUrl = () => {




  return `/api/task-fields`
}

/**
 * @summary Create a new custom field on a list
 */
export const createTaskField = async (createTaskFieldRequest: CreateTaskFieldRequest, options?: Parameters<typeof customFetch>[1]): Promise<TaskField> => {

  return customFetch<TaskField>(getCreateTaskFieldUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createTaskFieldRequest)
  }
);}





export const getCreateTaskFieldMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTaskField>>, TError,{data: BodyType<CreateTaskFieldRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTaskField>>, TError,{data: BodyType<CreateTaskFieldRequest>}, TContext> => {

const mutationKey = ['createTaskField'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTaskField>>, {data: BodyType<CreateTaskFieldRequest>}> = (props) => {
          const {data} = props ?? {};

          return  createTaskField(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTaskFieldMutationResult = NonNullable<Awaited<ReturnType<typeof createTaskField>>>
    export type CreateTaskFieldMutationBody = BodyType<CreateTaskFieldRequest>
    export type CreateTaskFieldMutationError = ErrorType<ApiError>

    /**
 * @summary Create a new custom field on a list
 */
export const useCreateTaskField = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTaskField>>, TError,{data: BodyType<CreateTaskFieldRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createTaskField>>,
        TError,
        {data: BodyType<CreateTaskFieldRequest>},
        TContext
      > => {
      return useMutation(getCreateTaskFieldMutationOptions(options));
    }

export const getUpdateTaskFieldUrl = (id: number,) => {




  return `/api/task-fields/${id}`
}

/**
 * @summary Rename a field, change its options, or change its type
 */
export const updateTaskField = async (id: number,
    updateTaskFieldRequest: UpdateTaskFieldRequest, options?: Parameters<typeof customFetch>[1]): Promise<TaskField> => {

  return customFetch<TaskField>(getUpdateTaskFieldUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateTaskFieldRequest)
  }
);}





export const getUpdateTaskFieldMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTaskField>>, TError,{id: number;data: BodyType<UpdateTaskFieldRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTaskField>>, TError,{id: number;data: BodyType<UpdateTaskFieldRequest>}, TContext> => {

const mutationKey = ['updateTaskField'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTaskField>>, {id: number;data: BodyType<UpdateTaskFieldRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateTaskField(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTaskFieldMutationResult = NonNullable<Awaited<ReturnType<typeof updateTaskField>>>
    export type UpdateTaskFieldMutationBody = BodyType<UpdateTaskFieldRequest>
    export type UpdateTaskFieldMutationError = ErrorType<ApiError>

    /**
 * @summary Rename a field, change its options, or change its type
 */
export const useUpdateTaskField = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTaskField>>, TError,{id: number;data: BodyType<UpdateTaskFieldRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateTaskField>>,
        TError,
        {id: number;data: BodyType<UpdateTaskFieldRequest>},
        TContext
      > => {
      return useMutation(getUpdateTaskFieldMutationOptions(options));
    }

export const getDeleteTaskFieldUrl = (id: number,) => {




  return `/api/task-fields/${id}`
}

/**
 * @summary Delete a custom field — every task's value for it is deleted too (cascade)
 */
export const deleteTaskField = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDeleteTaskFieldUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteTaskFieldMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTaskField>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTaskField>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteTaskField'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTaskField>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteTaskField(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTaskFieldMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTaskField>>>

    export type DeleteTaskFieldMutationError = ErrorType<ApiError>

    /**
 * @summary Delete a custom field — every task's value for it is deleted too (cascade)
 */
export const useDeleteTaskField = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTaskField>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteTaskField>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteTaskFieldMutationOptions(options));
    }

export const getAddTaskFieldToListUrl = (id: number,) => {




  return `/api/task-fields/${id}/lists`
}

/**
 * @summary Add an existing field to another list — one shared definition, not a copy
 */
export const addTaskFieldToList = async (id: number,
    addTaskFieldToListRequest: AddTaskFieldToListRequest, options?: Parameters<typeof customFetch>[1]): Promise<TaskField> => {

  return customFetch<TaskField>(getAddTaskFieldToListUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(addTaskFieldToListRequest)
  }
);}





export const getAddTaskFieldToListMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addTaskFieldToList>>, TError,{id: number;data: BodyType<AddTaskFieldToListRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addTaskFieldToList>>, TError,{id: number;data: BodyType<AddTaskFieldToListRequest>}, TContext> => {

const mutationKey = ['addTaskFieldToList'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addTaskFieldToList>>, {id: number;data: BodyType<AddTaskFieldToListRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  addTaskFieldToList(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddTaskFieldToListMutationResult = NonNullable<Awaited<ReturnType<typeof addTaskFieldToList>>>
    export type AddTaskFieldToListMutationBody = BodyType<AddTaskFieldToListRequest>
    export type AddTaskFieldToListMutationError = ErrorType<ApiError>

    /**
 * @summary Add an existing field to another list — one shared definition, not a copy
 */
export const useAddTaskFieldToList = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addTaskFieldToList>>, TError,{id: number;data: BodyType<AddTaskFieldToListRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof addTaskFieldToList>>,
        TError,
        {id: number;data: BodyType<AddTaskFieldToListRequest>},
        TContext
      > => {
      return useMutation(getAddTaskFieldToListMutationOptions(options));
    }

export const getRemoveTaskFieldFromListUrl = (id: number,
    listId: number,) => {




  return `/api/task-fields/${id}/lists/${listId}`
}

/**
 * @summary Remove a field from one list — the definition and every task's value survive, they just stop showing on that list
 */
export const removeTaskFieldFromList = async (id: number,
    listId: number, options?: Parameters<typeof customFetch>[1]): Promise<TaskField> => {

  return customFetch<TaskField>(getRemoveTaskFieldFromListUrl(id,listId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getRemoveTaskFieldFromListMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeTaskFieldFromList>>, TError,{id: number;listId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof removeTaskFieldFromList>>, TError,{id: number;listId: number}, TContext> => {

const mutationKey = ['removeTaskFieldFromList'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeTaskFieldFromList>>, {id: number;listId: number}> = (props) => {
          const {id,listId} = props ?? {};

          return  removeTaskFieldFromList(id,listId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveTaskFieldFromListMutationResult = NonNullable<Awaited<ReturnType<typeof removeTaskFieldFromList>>>

    export type RemoveTaskFieldFromListMutationError = ErrorType<ApiError>

    /**
 * @summary Remove a field from one list — the definition and every task's value survive, they just stop showing on that list
 */
export const useRemoveTaskFieldFromList = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeTaskFieldFromList>>, TError,{id: number;listId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof removeTaskFieldFromList>>,
        TError,
        {id: number;listId: number},
        TContext
      > => {
      return useMutation(getRemoveTaskFieldFromListMutationOptions(options));
    }

export const getGetTaskFieldValuesUrl = () => {




  return `/api/task-field-values`
}

/**
 * @summary List every set field value across every task — one row per (task, field) that actually has a value, not every possible pair
 */
export const getTaskFieldValues = async ( options?: Parameters<typeof customFetch>[1]): Promise<TaskFieldValue[]> => {

  return customFetch<TaskFieldValue[]>(getGetTaskFieldValuesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTaskFieldValuesQueryKey = () => {
    return [
    `/api/task-field-values`
    ] as const;
    }


export const getGetTaskFieldValuesQueryOptions = <TData = Awaited<ReturnType<typeof getTaskFieldValues>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTaskFieldValues>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTaskFieldValuesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTaskFieldValues>>> = ({ signal }) => getTaskFieldValues({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTaskFieldValues>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTaskFieldValuesQueryResult = NonNullable<Awaited<ReturnType<typeof getTaskFieldValues>>>
export type GetTaskFieldValuesQueryError = ErrorType<unknown>


/**
 * @summary List every set field value across every task — one row per (task, field) that actually has a value, not every possible pair
 */

export function useGetTaskFieldValues<TData = Awaited<ReturnType<typeof getTaskFieldValues>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTaskFieldValues>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTaskFieldValuesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpsertTaskFieldValueUrl = () => {




  return `/api/task-field-values`
}

/**
 * @summary Set a task's value for a field — creates the row on first set, updates it after
 */
export const upsertTaskFieldValue = async (upsertTaskFieldValueRequest: UpsertTaskFieldValueRequest, options?: Parameters<typeof customFetch>[1]): Promise<TaskFieldValue> => {

  return customFetch<TaskFieldValue>(getUpsertTaskFieldValueUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(upsertTaskFieldValueRequest)
  }
);}





export const getUpsertTaskFieldValueMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertTaskFieldValue>>, TError,{data: BodyType<UpsertTaskFieldValueRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof upsertTaskFieldValue>>, TError,{data: BodyType<UpsertTaskFieldValueRequest>}, TContext> => {

const mutationKey = ['upsertTaskFieldValue'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upsertTaskFieldValue>>, {data: BodyType<UpsertTaskFieldValueRequest>}> = (props) => {
          const {data} = props ?? {};

          return  upsertTaskFieldValue(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpsertTaskFieldValueMutationResult = NonNullable<Awaited<ReturnType<typeof upsertTaskFieldValue>>>
    export type UpsertTaskFieldValueMutationBody = BodyType<UpsertTaskFieldValueRequest>
    export type UpsertTaskFieldValueMutationError = ErrorType<ApiError>

    /**
 * @summary Set a task's value for a field — creates the row on first set, updates it after
 */
export const useUpsertTaskFieldValue = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertTaskFieldValue>>, TError,{data: BodyType<UpsertTaskFieldValueRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof upsertTaskFieldValue>>,
        TError,
        {data: BodyType<UpsertTaskFieldValueRequest>},
        TContext
      > => {
      return useMutation(getUpsertTaskFieldValueMutationOptions(options));
    }

export const getDeleteTaskFieldValueUrl = (taskId: number,
    fieldId: number,) => {




  return `/api/task-field-values/${taskId}/${fieldId}`
}

/**
 * @summary Clear a task's value for a field
 */
export const deleteTaskFieldValue = async (taskId: number,
    fieldId: number, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDeleteTaskFieldValueUrl(taskId,fieldId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteTaskFieldValueMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTaskFieldValue>>, TError,{taskId: number;fieldId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTaskFieldValue>>, TError,{taskId: number;fieldId: number}, TContext> => {

const mutationKey = ['deleteTaskFieldValue'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTaskFieldValue>>, {taskId: number;fieldId: number}> = (props) => {
          const {taskId,fieldId} = props ?? {};

          return  deleteTaskFieldValue(taskId,fieldId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTaskFieldValueMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTaskFieldValue>>>

    export type DeleteTaskFieldValueMutationError = ErrorType<ApiError>

    /**
 * @summary Clear a task's value for a field
 */
export const useDeleteTaskFieldValue = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTaskFieldValue>>, TError,{taskId: number;fieldId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteTaskFieldValue>>,
        TError,
        {taskId: number;fieldId: number},
        TContext
      > => {
      return useMutation(getDeleteTaskFieldValueMutationOptions(options));
    }

export const getGetRulesUrl = () => {




  return `/api/rules`
}

/**
 * @summary Get all AI rules
 */
export const getRules = async ( options?: Parameters<typeof customFetch>[1]): Promise<Rule[]> => {

  return customFetch<Rule[]>(getGetRulesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetRulesQueryKey = () => {
    return [
    `/api/rules`
    ] as const;
    }


export const getGetRulesQueryOptions = <TData = Awaited<ReturnType<typeof getRules>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRules>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRulesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRules>>> = ({ signal }) => getRules({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRules>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRulesQueryResult = NonNullable<Awaited<ReturnType<typeof getRules>>>
export type GetRulesQueryError = ErrorType<unknown>


/**
 * @summary Get all AI rules
 */

export function useGetRules<TData = Awaited<ReturnType<typeof getRules>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRules>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetRulesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateRuleUrl = () => {




  return `/api/rules`
}

/**
 * @summary Create a new AI rule
 */
export const createRule = async (ruleInput: RuleInput, options?: Parameters<typeof customFetch>[1]): Promise<Rule> => {

  return customFetch<Rule>(getCreateRuleUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(ruleInput)
  }
);}





export const getCreateRuleMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRule>>, TError,{data: BodyType<RuleInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createRule>>, TError,{data: BodyType<RuleInput>}, TContext> => {

const mutationKey = ['createRule'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createRule>>, {data: BodyType<RuleInput>}> = (props) => {
          const {data} = props ?? {};

          return  createRule(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateRuleMutationResult = NonNullable<Awaited<ReturnType<typeof createRule>>>
    export type CreateRuleMutationBody = BodyType<RuleInput>
    export type CreateRuleMutationError = ErrorType<unknown>

    /**
 * @summary Create a new AI rule
 */
export const useCreateRule = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRule>>, TError,{data: BodyType<RuleInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createRule>>,
        TError,
        {data: BodyType<RuleInput>},
        TContext
      > => {
      return useMutation(getCreateRuleMutationOptions(options));
    }

export const getDeleteRuleUrl = (id: number,) => {




  return `/api/rules/${id}`
}

/**
 * @summary Delete an AI rule
 */
export const deleteRule = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDeleteRuleUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteRuleMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRule>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteRule>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteRule'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteRule>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteRule(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteRuleMutationResult = NonNullable<Awaited<ReturnType<typeof deleteRule>>>

    export type DeleteRuleMutationError = ErrorType<ApiError>

    /**
 * @summary Delete an AI rule
 */
export const useDeleteRule = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRule>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteRule>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteRuleMutationOptions(options));
    }

export const getGetStatsUrl = () => {




  return `/api/stats`
}

/**
 * @summary Get inbox statistics
 */
export const getStats = async ( options?: Parameters<typeof customFetch>[1]): Promise<InboxStats> => {

  return customFetch<InboxStats>(getGetStatsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetStatsQueryKey = () => {
    return [
    `/api/stats`
    ] as const;
    }


export const getGetStatsQueryOptions = <TData = Awaited<ReturnType<typeof getStats>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStats>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStatsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStats>>> = ({ signal }) => getStats({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStats>>, TError, TData> & { queryKey: QueryKey }
}

export type GetStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getStats>>>
export type GetStatsQueryError = ErrorType<unknown>


/**
 * @summary Get inbox statistics
 */

export function useGetStats<TData = Awaited<ReturnType<typeof getStats>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStats>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetStatsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetAnalyticsUrl = (params: GetAnalyticsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/analytics?${stringifiedParams}` : `/api/analytics`
}

/**
 * @summary Productivity analytics for a date range — completion/status/priority breakdowns and focus-time (task time block) trends, optionally compared against a prior period.
 */
export const getAnalytics = async (params: GetAnalyticsParams, options?: Parameters<typeof customFetch>[1]): Promise<AnalyticsResponse> => {

  return customFetch<AnalyticsResponse>(getGetAnalyticsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAnalyticsQueryKey = (params?: GetAnalyticsParams,) => {
    return [
    `/api/analytics`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAnalyticsQueryOptions = <TData = Awaited<ReturnType<typeof getAnalytics>>, TError = ErrorType<ApiError>>(params: GetAnalyticsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAnalytics>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAnalyticsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnalytics>>> = ({ signal }) => getAnalytics(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAnalytics>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAnalyticsQueryResult = NonNullable<Awaited<ReturnType<typeof getAnalytics>>>
export type GetAnalyticsQueryError = ErrorType<ApiError>


/**
 * @summary Productivity analytics for a date range — completion/status/priority breakdowns and focus-time (task time block) trends, optionally compared against a prior period.
 */

export function useGetAnalytics<TData = Awaited<ReturnType<typeof getAnalytics>>, TError = ErrorType<ApiError>>(
 params: GetAnalyticsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAnalytics>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAnalyticsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListAnthropicConversationsUrl = () => {




  return `/api/anthropic/conversations`
}

/**
 * @summary List all conversations
 */
export const listAnthropicConversations = async ( options?: Parameters<typeof customFetch>[1]): Promise<AnthropicConversation[]> => {

  return customFetch<AnthropicConversation[]>(getListAnthropicConversationsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAnthropicConversationsQueryKey = () => {
    return [
    `/api/anthropic/conversations`
    ] as const;
    }


export const getListAnthropicConversationsQueryOptions = <TData = Awaited<ReturnType<typeof listAnthropicConversations>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAnthropicConversations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAnthropicConversationsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAnthropicConversations>>> = ({ signal }) => listAnthropicConversations({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAnthropicConversations>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAnthropicConversationsQueryResult = NonNullable<Awaited<ReturnType<typeof listAnthropicConversations>>>
export type ListAnthropicConversationsQueryError = ErrorType<unknown>


/**
 * @summary List all conversations
 */

export function useListAnthropicConversations<TData = Awaited<ReturnType<typeof listAnthropicConversations>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAnthropicConversations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAnthropicConversationsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateAnthropicConversationUrl = () => {




  return `/api/anthropic/conversations`
}

/**
 * @summary Create a new conversation
 */
export const createAnthropicConversation = async (anthropicConversationInput: AnthropicConversationInput, options?: Parameters<typeof customFetch>[1]): Promise<AnthropicConversation> => {

  return customFetch<AnthropicConversation>(getCreateAnthropicConversationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(anthropicConversationInput)
  }
);}





export const getCreateAnthropicConversationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAnthropicConversation>>, TError,{data: BodyType<AnthropicConversationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createAnthropicConversation>>, TError,{data: BodyType<AnthropicConversationInput>}, TContext> => {

const mutationKey = ['createAnthropicConversation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAnthropicConversation>>, {data: BodyType<AnthropicConversationInput>}> = (props) => {
          const {data} = props ?? {};

          return  createAnthropicConversation(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAnthropicConversationMutationResult = NonNullable<Awaited<ReturnType<typeof createAnthropicConversation>>>
    export type CreateAnthropicConversationMutationBody = BodyType<AnthropicConversationInput>
    export type CreateAnthropicConversationMutationError = ErrorType<unknown>

    /**
 * @summary Create a new conversation
 */
export const useCreateAnthropicConversation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAnthropicConversation>>, TError,{data: BodyType<AnthropicConversationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createAnthropicConversation>>,
        TError,
        {data: BodyType<AnthropicConversationInput>},
        TContext
      > => {
      return useMutation(getCreateAnthropicConversationMutationOptions(options));
    }

export const getGetAnthropicConversationUrl = (id: number,) => {




  return `/api/anthropic/conversations/${id}`
}

/**
 * @summary Get conversation with messages
 */
export const getAnthropicConversation = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<AnthropicConversationWithMessages> => {

  return customFetch<AnthropicConversationWithMessages>(getGetAnthropicConversationUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAnthropicConversationQueryKey = (id: number,) => {
    return [
    `/api/anthropic/conversations/${id}`
    ] as const;
    }


export const getGetAnthropicConversationQueryOptions = <TData = Awaited<ReturnType<typeof getAnthropicConversation>>, TError = ErrorType<AnthropicError>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAnthropicConversation>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAnthropicConversationQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnthropicConversation>>> = ({ signal }) => getAnthropicConversation(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAnthropicConversation>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAnthropicConversationQueryResult = NonNullable<Awaited<ReturnType<typeof getAnthropicConversation>>>
export type GetAnthropicConversationQueryError = ErrorType<AnthropicError>


/**
 * @summary Get conversation with messages
 */

export function useGetAnthropicConversation<TData = Awaited<ReturnType<typeof getAnthropicConversation>>, TError = ErrorType<AnthropicError>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAnthropicConversation>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAnthropicConversationQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getDeleteAnthropicConversationUrl = (id: number,) => {




  return `/api/anthropic/conversations/${id}`
}

/**
 * @summary Delete a conversation
 */
export const deleteAnthropicConversation = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDeleteAnthropicConversationUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteAnthropicConversationMutationOptions = <TError = ErrorType<AnthropicError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAnthropicConversation>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAnthropicConversation>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteAnthropicConversation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAnthropicConversation>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteAnthropicConversation(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAnthropicConversationMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAnthropicConversation>>>

    export type DeleteAnthropicConversationMutationError = ErrorType<AnthropicError>

    /**
 * @summary Delete a conversation
 */
export const useDeleteAnthropicConversation = <TError = ErrorType<AnthropicError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAnthropicConversation>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteAnthropicConversation>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteAnthropicConversationMutationOptions(options));
    }

export const getListAnthropicMessagesUrl = (id: number,) => {




  return `/api/anthropic/conversations/${id}/messages`
}

/**
 * @summary List messages in a conversation
 */
export const listAnthropicMessages = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<AnthropicMessage[]> => {

  return customFetch<AnthropicMessage[]>(getListAnthropicMessagesUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAnthropicMessagesQueryKey = (id: number,) => {
    return [
    `/api/anthropic/conversations/${id}/messages`
    ] as const;
    }


export const getListAnthropicMessagesQueryOptions = <TData = Awaited<ReturnType<typeof listAnthropicMessages>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAnthropicMessages>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAnthropicMessagesQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAnthropicMessages>>> = ({ signal }) => listAnthropicMessages(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAnthropicMessages>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAnthropicMessagesQueryResult = NonNullable<Awaited<ReturnType<typeof listAnthropicMessages>>>
export type ListAnthropicMessagesQueryError = ErrorType<unknown>


/**
 * @summary List messages in a conversation
 */

export function useListAnthropicMessages<TData = Awaited<ReturnType<typeof listAnthropicMessages>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAnthropicMessages>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAnthropicMessagesQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSendAnthropicMessageUrl = (id: number,) => {




  return `/api/anthropic/conversations/${id}/messages`
}

/**
 * @summary Send a message and receive an AI response (SSE stream)
 */
export const sendAnthropicMessage = async (id: number,
    anthropicMessageInput: AnthropicMessageInput, options?: Parameters<typeof customFetch>[1]): Promise<unknown> => {

  return customFetch<unknown>(getSendAnthropicMessageUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(anthropicMessageInput)
  }
);}





export const getSendAnthropicMessageMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendAnthropicMessage>>, TError,{id: number;data: BodyType<AnthropicMessageInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof sendAnthropicMessage>>, TError,{id: number;data: BodyType<AnthropicMessageInput>}, TContext> => {

const mutationKey = ['sendAnthropicMessage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendAnthropicMessage>>, {id: number;data: BodyType<AnthropicMessageInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  sendAnthropicMessage(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendAnthropicMessageMutationResult = NonNullable<Awaited<ReturnType<typeof sendAnthropicMessage>>>
    export type SendAnthropicMessageMutationBody = BodyType<AnthropicMessageInput>
    export type SendAnthropicMessageMutationError = ErrorType<unknown>

    /**
 * @summary Send a message and receive an AI response (SSE stream)
 */
export const useSendAnthropicMessage = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendAnthropicMessage>>, TError,{id: number;data: BodyType<AnthropicMessageInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendAnthropicMessage>>,
        TError,
        {id: number;data: BodyType<AnthropicMessageInput>},
        TContext
      > => {
      return useMutation(getSendAnthropicMessageMutationOptions(options));
    }

